<template>
  <div>
    <m-tabbar style="z-index: 100;margin-bottom: 64px;" v-if="mTabbarType"></m-tabbar>
    <div class="manageNew">
      <div class="bodyLeft">
        <h3>班级列表</h3>
        <div>
          <p
            v-for="(item1, index1) in formData.classList"
            :key="index1"
            :class="
              classIndex !== '' && classIndex == index1 ? 'classActive' : ''
            "
            @click="selectClass(item1, index1)"
            style="display:block;"
          >{{ item1.className }}</p>
        </div>
      </div>
      <div class="bodyRight">
        <!-- 头部选择 -->
        <div class="headFixed">
          <div class="boxFirst">
            <ul class="selectHead">
              <template v-for="(item, index) in tabs">
                <li
                  v-if="item.display"
                  :key="index"
                  :class="{ liContent: item.id == currTab }"
                  @click="selectTab(item.id)"
                >{{ item.name }}</li>
              </template>
              <!--  <li
                v-if="$store.getters.orgid == 18"
                :class="{ liContent: 3 == currTab }"
                @click="selectTab(3)"
              >
                问卷调查
              </li>-->
            </ul>
            
            <p class="dataend">
              <template>
                <a-tooltip placement="topRight">
                  <template slot="title">
                    一键还原
                  </template>
                  <a-icon type="reload" style="font-size:25px;padding-right:10px;" @click="reduction()"/>
                </a-tooltip>
              </template>
              
              统计数据截止于：{{
              moment(new Date())
              .add(0, "days")
              .format("YYYY-MM-DD")
              }}
              00:00:00
            </p>
          </div>
          <div style="padding:15px 15px 0;" v-if="currTab != 4">
            <a-form layout="inline">
              <a-form-item label="学段">
                <a-select placeholder="请选择" style="width:100px" v-model="formData.stageid">
                  <a-select-option value="0" @click="changeStage('0')">全部</a-select-option>
                  <a-select-option
                    v-for="(item, index) in formData.stageData"
                    :key="index"
                    :value="item.stageid"
                    @click="changeStage(item)"
                  >{{ item.stageName }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="年级">
                <a-select placeholder="请选择" style="width:100px" v-model="formData.gradeIds">
                  <a-select-option value="0" @click="changeGrade('0')">全部</a-select-option>
                  <a-select-option
                    v-for="(item, index) in formData.gradeList"
                    :key="index"
                    :value="item.gradeIds"
                    @click="changeGrade(item)"
                  >{{ item.gradeName }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="学科">
                <a-select placeholder="请选择" style="width:150px" v-model="subjectName">
                  <a-select-option value="0" @click="changeSubjects('0')">全部</a-select-option>
                  <a-select-option
                    v-for="(item, index) in formData.subjectsList"
                    :key="index+1"
                    
                    @click="changeSubjects(item)"
                  >{{ item.subjectName }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="时段：" style="float:right" v-if="currTab != '3'">
                <a-range-picker
                  style="width:250px;text-align:left;margin-right:10px;"
                  :allowClear="false"
                  :disabledDate="disabledDate"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeTime"
                  :value="[moment(form.startTime), moment(form.endTime)]"
                />
                <a-select
                  placeholder="请选择"
                  style="width:100px"
                  v-model="size"
                  @change="TimeChange($event)"
                >
                  <a-select-option value="0">近一周</a-select-option>
                  <a-select-option value="1">近一月</a-select-option>
                  <a-select-option value="2">本学期</a-select-option>
                  <a-select-option value="3" class="noneSelect">无</a-select-option>
                </a-select>
              </a-form-item>
            </a-form>
          </div>
          <div v-else class="deviceDetails-header">
            <div class="deviceDetails-select">
              <a-radio-group v-model="getDeviceDetailsInfoParams.weekOrMonth" @change="radioChange">
                <a-radio-button :value="1">近一周</a-radio-button>
                <a-radio-button :value="2">近一月</a-radio-button>
              </a-radio-group>
              <span>
                <a-select
                  placeholder="请选择月份"
                  notFoundContent="暂无数据"
                  style="width: 120px"
                  :style="
                    getDeviceDetailsInfoParams.weekOrMonth == 0
                      ? 'color:#1089ff;'
                      : ''
                  "
                  @change="dateChange"
                >
                  <a-select-option
                    v-for="(item, index) in monthList"
                    :key="index"
                    :value="item"
                  >{{ item }}</a-select-option>
                </a-select>
              </span>
            </div>
            <div class="deviceDetails-info">
              <div style="position:relative;">
                <p>
                  <b>{{ deviceDetailsInfo.stuDeviceNum }} 台</b>
                </p>
                <p>设备使用总数</p>

                <div class="tips">
                  <a-tooltip placement="top" overlayClassName="tips-content">
                    <template slot="title">统计设备为学生平板</template>
                    <a-icon type="question-circle" />
                  </a-tooltip>
                </div>
              </div>
              <div>
                <p>
                  <b>{{ deviceDetailsInfo.stuDeviceOnlineNum }} 人</b>
                </p>
                <p>实时在线设备</p>
              </div>
              <div>
                <p>
                  <b>{{ deviceDetailsInfo.stuDeviceDailyNum }} 人</b>
                </p>
                <p>日均使用设备</p>
              </div>
              <div style="position:relative;">
                <p>
                  <b>{{ deviceDetailsInfo.stuDeviceAnomalyNum }} 台</b>
                </p>
                <p>日均网络异常</p>

                <div class="tips">
                  <a-tooltip placement="top" overlayClassName="tips-content">
                    <template slot="title">每天网络断开连接次数超过10次,系统判定为网络异常</template>
                    <a-icon type="question-circle" />
                  </a-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail-box" :class="currTab == 4 ? ' deviceDetails-box' : ''">
          <!-- 作业总况 -->
          <div v-if="currTab == '0'">
            <!-- 2 -->
            <div class="boxSecond">
              <ul>
                <li>
                  <img src="../../assets/images/manage_1.png" alt />
                  <div>
                    <p>使用老师</p>
                    <h3>{{ headList.teachernum }}人</h3>
                  </div>
                </li>
                <li>
                  <img src="../../assets/images/manage_2.png" alt />
                  <div>
                    <p>使用学生</p>
                    <h3>{{ headList.studentnum }}人</h3>
                  </div>
                </li>
                <li>
                  <img src="../../assets/images/manage_3.png" alt />
                  <div>
                    <p>布置作业次数</p>
                    <h3>{{ headList.allExercise }}次</h3>
                  </div>
                </li>
                <li>
                  <img src="../../assets/images/manage_4.png" alt />
                  <div>
                    <p>作业总题量</p>
                    <h3>{{ headList.allQuestion }}题</h3>
                  </div>
                </li>
                <li>
                  <img src="../../assets/images/manage_5.png" alt />
                  <div>
                    <p>作业交齐比例</p>
                    <h3>
                      {{ headList.pushexercount }} /
                      {{ headList.publishexercount }}份
                    </h3>
                  </div>
                </li>
                <li>
                  <img src="../../assets/images/manage_6.png" alt />
                  <div>
                    <p>迟交作业比例</p>
                    <h3>
                      {{ headList.delayexercisecount }} /
                      {{ headList.publishexercount }}份
                    </h3>
                  </div>
                </li>
                <li>
                  <img src="../../assets/images/manage_7.png" alt />
                  <div>
                    <p>平均批改率</p>
                    <h3>{{ headList.correctRate }}%</h3>
                  </div>
                </li>
                <li>
                  <img src="../../assets/images/manage_8.png" alt />
                  <div>
                    <p>错题订正率</p>
                    <h3>{{ headList.revisionRate }}%</h3>
                  </div>
                </li>
              </ul>
              <div>
                <div class="timeLeft">
                  <highcharts
                    v-if="analyseSize == 0 && submitArr.length != 0"
                    :options="aveTime"
                    ref="highcharts"
                  ></highcharts>
                  <highcharts
                    v-if="analyseSize == 1 && arrTime.length != 0"
                    :options="timeConsuming"
                    ref="highcharts"
                  ></highcharts>
                  <p class="nocharts" v-if="analyseSize == 0 && submitArr.length == 0">暂无数据</p>
                  <p class="nocharts" v-if="analyseSize == 1 && arrTime.length == 0">暂无数据</p>
                  <div class="tabanalyse">
                    <a-radio-group v-model="analyseSize">
                      <a-radio-button value="0">提交时间分布</a-radio-button>
                      <a-radio-button value="1">作业用时趋势</a-radio-button>
                    </a-radio-group>
                  </div>
                </div>
                <div class="cakeRight">
                  <div class="cakaTitle">
                    <a-tooltip>
                      <template
                        slot="title"
                      >以得分率区间划分，鼠标移至环形块，若年级条件为全部，可查看该等级的全部人数，若年级为具体年级时，可查看该等级的各班人数</template>
                      <i>学生成绩等级分布</i>
                      <a-icon type="question-circle" theme="outlined" />
                    </a-tooltip>
                  </div>
                  <highcharts
                    v-if="cakeNo"
                    :options="aveScore"
                    ref="highcharts"
                    style="padding-left:20px"
                  ></highcharts>
                  <p class="nocharts" v-if="!cakeNo">暂无数据</p>
                </div>
              </div>
            </div>
            <!-- 3 -->
            <div class="boxThird">
              <h1>全部作业：</h1>
              <a-table
                bordered
                :rowKey="(record, index) => index"
                :dataSource="dataSource"
                :columns="columns"
                :pagination="pagination"
                :loading="loadingTable"
                :scroll="{ x: 1500 }"
                @change="handleTableChange($event)"
                :locale="{ emptyText: '暂无数据' }"
                :rowClassName="
                  (record, index) => {
                    let className = 'lightrow'
                    if (index % 2 === 1) className = 'darkrow'
                    return className
                  }
                "
              >
                <span slot="submit" slot-scope="record">
                  <a-tag
                    :color="
                      record.submitcount == record.studentcount
                        ? ''
                        : 'rgb(236 66 75)'
                    "
                  >{{ record.submit }}</a-tag>
                </span>

                <span slot="scoreRate">
                  <a-tooltip>
                    <template slot="title">
                      （该次作业的全部学生得分之和）/（作业总分*已批改的人数）*
                      100%
                    </template>得分率
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </span>
                <span slot="scoreRate" slot-scope="record">
                  <a-tag
                    :color="
                      record.scoreRate >= 80
                        ? '#53C41A'
                        : record.scoreRate < 50
                        ? 'rgb(236 66 75)'
                        : '#EBA215'
                    "
                  >{{ record.scoreRate | parseFloat }}%</a-tag>
                </span>


                <span slot="correctRate">
                  <a-tooltip>
                    <template slot="title">已批改的学生数/提交作业的人数* 100%</template>批改率
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </span>
                <span slot="correctRate" slot-scope="record">
                  <a-tag
                    :color="
                      90 <= record.correctRate && record.correctRate < 100
                        ? '#EBA215'
                        : record.correctRate < 90
                        ? 'rgb(236 66 75)'
                        : ''
                    "
                  >{{ record.correctRate | parseFloat }}%</a-tag>
                </span>
                <span slot="revisionCorrectRate">
                  <a-tooltip>
                    <template slot="title">（已批改的订正人数）/（提交订正的人数）* 100%</template>订正批改率
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </span>
                <span
                  slot="revisionCorrectRate"
                  slot-scope="record"
                >{{ record.revisionCorrectRate | parseFloat }}%</span>
                <span slot="revisionwrong">
                  <a-tooltip>
                    <template slot="title">
                      n / m，n表示本次作业提交订正的人次
                      ，m表示本次作业错题人次
                    </template>订正人次
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </span>




                
                <span slot="rightRate" slot-scope="record">
                  <a-tag>{{ record.rightRate | parseFloat }}%</a-tag>
                  <!-- :color="
                      record.rightRate >= 80
                        ? '#53C41A'
                        : record.rightRate < 50
                        ? 'rgb(236 66 75)'
                        : '#EBA215'
                    " -->
                </span>
                <!-- <span slot="rightRate">
                  <a-tooltip>
                    <template slot="title">
                      （该次作业的各题正确人次之和）/（总题数*已批改的人数）*
                      100%
                    </template>完对率
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </span> -->




                <span slot="outstandingRate">
                  <a-tooltip>
                    <template slot="title">
                      （得分率大于等于85%的人数）/（已批改的人数）*
                      100%
                    </template>优秀率
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </span>
                <span slot="failRate">
                  <a-tooltip>
                    <template slot="title">（得分率小于60的人数）/（已批改的人数）* 100%</template>不及格率
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </span>
              </a-table>
            </div>
          </div>
          <!-- 详细分析 -->
          <div v-if="currTab == '1'">
            <div class="boxThird" v-show="formData.classid == 0">
              
              <div class="common"><div  style="display:inline-block;font-size:16px;font-weight:600;">各科老师分析：</div>
              <a class="export" @click="subjectTableToExcel()">分析数据导出</a>
              <a class="export" @click="originalSubjectToExcel()">原始数据导出</a> 
            </div>
              <div class="handTable">
                <div ref="handTitle">
                    <div class="handContent" :data-id="JSON.stringify(item)"  v-for="(item,index) in teacherAnalyse" :key="index" style="display:inline-block;">
                      <div class="handHead">
                          <a-tooltip v-if="item.tips" style="font-weight:600;">
                            <template slot="title">
                              <span v-html="item.tips"></span>
                            </template>
                            {{ item.title }}
                            <a-icon type="question-circle" theme="outlined" />
                          </a-tooltip>
                          <template v-else>
                            {{ item.title }}
                          </template>
                        <a-checkbox v-if="showCheckbox" style="margin-left:4px;" :checked="item.isCheck" @change="onTeacherChange(item)"></a-checkbox>
                      </div>
                      <div class="handBody" :class="getColorStyle(dataValue.value,item.id,item.title)" v-for="(dataValue,index2) in item.data" :key="index2" @click="toDetail(dataValue, 1)">{{ dataValue.value }}</div>
                    </div>
                </div>
              </div>
              
              <div v-if="loadingTeach" style="position:fixed;margin-left:40%;top:50%;z-index:99;">
                <a-spin size="large" />
              </div>
              <p v-if="teacherList.length == 0" class="noData">暂无数据</p>
            </div>
            <div class="boxThird" style="margin-bottom:20px;">
              <div class="common"><div style="display:inline-block;font-size:16px;font-weight:600;">班级使用分析：</div><a class="export" @click="classTableToExcel()">分析数据导出</a><a class="export" @click="originalClassToExcel()">原始数据导出</a></div>
              <div class="handTable moreLength">
                  <div ref="handTitle2">
                      <div class="handContent" :data-id="JSON.stringify(item)"  v-for="(item,index) in classAnalyse" :key="index" style="display:inline-block;">
                        <div class="handHead">
                          <a-tooltip v-if="item.tips" style="font-weight:600;">
                            <template slot="title">
                              <span v-html="item.tips"></span>
                              <!-- {{ item.tips |  wrap}} -->
                            </template>
                            {{ item.title }}
                            <a-icon type="question-circle" theme="outlined" />
                          </a-tooltip>
                          <template v-else>
                            {{ item.title }}
                          </template>
                          <a-checkbox v-if="classShowCheckbox" style="margin-left:4px;" :checked="item.isCheck" @change="onClassChange(item)"></a-checkbox>
                        </div>
                        <div class="handBody" :class="getColorStyle(dataValue.value,item.id,item.title)" v-for="(dataValue,index2) in item.data" :key="index2" @click="toDetail(dataValue, 1)">{{ dataValue.value }}</div>
                      </div>
                  </div>
              </div>
              <p v-if="classData.length == 0" class="noData">暂无数据</p>
            </div>
            <!-- 具体班级 -->
            <div class="boxThird" v-show="formData.classid != 0">
              <h1>作业：</h1>
              <a-table
                bordered
                :rowKey="(record, index) => index"
                :dataSource="dataSource"
                :columns="columns"
                :pagination="pagination"
                :loading="loadingTable"
                :scroll="{ x: 1500 }"
                @change="handleTableChange($event)"
                :locale="{ emptyText: '暂无数据' }"
                :rowClassName="
                  (record, index) => {
                    let className = 'lightrow'
                    if (index % 2 === 1) className = 'darkrow'
                    return className
                  }
                "
              >
                <span slot="submit" slot-scope="record">
                  <a-tag
                    :color="
                      record.submitcount == record.studentcount
                        ? ''
                        : 'rgb(236 66 75)'
                    "
                  >{{ record.submit }}</a-tag>
                </span>



                <span slot="scoreRate">
                  <a-tooltip>
                    <template slot="title">
                      （该次作业的全部学生得分之和）/（作业总分*已批改的人数）*
                      100%
                    </template>得分率
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </span>
                <span slot="scoreRate" slot-scope="record">
                  <a-tag
                    :color="
                      record.scoreRate >= 80
                        ? '#53C41A'
                        : record.scoreRate < 50
                        ? 'rgb(236 66 75)'
                        : '#EBA215'
                    "
                  >{{ record.scoreRate | parseFloat }}%</a-tag>
                </span>


                <span slot="correctRate">
                  <a-tooltip>
                    <template slot="title">已批改的学生数/提交作业的人数* 100%</template>批改率
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </span>
                <span slot="correctRate" slot-scope="record">
                  <a-tag
                    :color="
                      90 <= record.correctRate && record.correctRate < 100
                        ? '#EBA215'
                        : record.correctRate < 90
                        ? 'rgb(236 66 75)'
                        : ''
                    "
                  >{{ record.correctRate | parseFloat }}%</a-tag>
                </span>
                <span slot="revisionCorrectRate">
                  <a-tooltip>
                    <template slot="title">（已批改的订正人数）/（提交订正的人数）* 100%</template>订正批改率
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </span>
                <span
                  slot="revisionCorrectRate"
                  slot-scope="record"
                >{{ record.revisionCorrectRate | parseFloat }}%</span>
                <span slot="revisionwrong">
                  <a-tooltip>
                    <template slot="title">
                      n / m，n表示本次作业提交订正的人次
                      ，m表示本次作业错题人次
                    </template>订正人次
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </span>
                <span slot="rightRate">
                  <a-tooltip>
                    <template slot="title">
                      （该次作业的各题正确人次之和）/（总题数*已批改的人数）*
                      100%
                    </template>完对率
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </span>
                <span slot="rightRate" slot-scope="record">
                  <a-tag>{{ record.rightRate | parseFloat }}%</a-tag>
                </span>
                <span slot="outstandingRate">
                  <a-tooltip>
                    <template slot="title">
                      （得分率大于等于85%的人数）/（已批改的人数）*
                      100%
                    </template>优秀率
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </span>
                <span slot="failRate">
                  <a-tooltip>
                    <template slot="title">（得分率小于60的人数）/（已批改的人数）* 100%</template>不及格率
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </span>
              </a-table>
            </div>
          </div>
          <!-- 教学质量 -->
          <div v-if="currTab == '2'">
            <div class="boxTeach">
              <h1>教学质量分析：</h1>
              <ul class="titleUl">
                <li class="l1">知识点</li>
                <li class="l2">所属学科</li>
                <li>老师</li>
                <li>考察次数</li>
                <li>作答人次</li>
                <li>
                  <a-tooltip>
                    <template slot="title">（该知识点每次得分率之和）/（考察次数）*100%</template>
                    得分率
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </li>
                <li>
                  <a-tooltip>
                    <template slot="title">（每次作业的错题订正人次之和）/（错题总人次）* 100%</template>
                    订正率
                    <a-icon type="question-circle" theme="outlined" />
                  </a-tooltip>
                </li>
              </ul>
              <ul class="detailUl">
                <li
                  v-for="(item, index) in knowledgeList.slice(
                    (knowpage.page - 1) * knowpage.pageSize,
                    knowpage.page * knowpage.pageSize
                  )"
                  :key="index"
                  :class="{ darkrow: index % 2 === 1 }"
                >
                  <div class="l1">{{ item.knowledgeName }}</div>
                  <div class="l2">
                    <span>{{ item.bankName }}</span>
                  </div>
                  <div>
                    <div class="liDiv" v-for="(i, j) in item.knowTeacherDataMessageList" :key="j">
                      <p @click="toDetail(i, 2)">
                        <!-- {{ fixTeaname(i.teacherName) }} -->
                        {{ i.teacherName }}
                      </p>
                      <p>{{ i.questime }}</p>
                      <p>{{ i.writequescount }}</p>
                      <p :class="getColor(i.scoreRate, 4)">{{ i.scoreRate | parseFloat }}%</p>
                      <p>{{ i.revisionRate | parseFloat }}%</p>
                    </div>
                  </div>
                </li>
              </ul>
              <p v-if="knowledgeList.length == 0" class="noData">暂无数据</p>
              <div v-if="loadingList" style="position:fixed;margin-left:40%;top:50%;z-index:99;">
                <a-spin size="large" />
              </div>
              <p style="text-align:right;margin:20px 0;">
                <a-pagination
                  :total="knowpage.rowCount"
                  :pageSize.sync="knowpage.pageSize"
                  v-model="knowpage.page"
                  @change="pageKnowledge"
                />
              </p>
            </div>
          </div>
          <!-- 问卷调查 -->
          <div class="nairBody" v-if="currTab == '3'">
            <div class="nairLi" v-for="(item, index) in quesnairtData" :key="index">
              <h2>{{ item.qNumber }}.{{ item.qContent }}</h2>
              <p v-if="formData.subjectId != 0">
                填写率
                {{ ((item.selectCounts / quesnairtStu) * 100) | parseFloat }}% /
                填写 {{ item.selectCounts }}人
              </p>
              <div class="progress" v-for="(i, index) in item.optionList" :key="index">
                <a-progress :strokeWidth="31" :showInfo="false" :percent="i.proportion" />
                <span class="pTitle">{{ i.content.slice(2) }}</span>
                <p class="pNum">
                  <span>{{ i.counts }}人</span>
                  <span>{{ i.proportion | parseFloat }}%</span>
                </p>
              </div>
            </div>
            <a-table
              class="nariTable"
              bordered
              :rowKey="(record, index) => index"
              :dataSource="stuSuggestionList"
              :columns="naircolumns"
              :locale="{ emptyText: '暂无数据' }"
              :rowClassName="
                (record, index) => {
                  let className = 'lightrow'
                  if (index % 2 === 1) className = 'nairdarkrow'
                  return className
                }
              "
            ></a-table>
          </div>
          <!-- 设备详情 -->
          <div class="deviceDetails" v-if="currTab == '4'">
            <a-spin :spinning="spinning" class="resetPosition">
              <highcharts
                :options="deviceChartOptions"
                ref="activeSituation"
                class="activeSituation"
              ></highcharts>
              <highcharts
                :options="networkMonitoringOptions"
                ref="networkMonitoring"
                class="networkMonitoring"
              ></highcharts>
              <highcharts :options="appDurationOptions" ref="appDuration" class="appDuration"></highcharts>
            </a-spin>
          </div>

          <a-modal
            v-model="modal1Visible"
            width="63%"
            centered
            :footer="null"
            @ok="() => (modal1Visible = false)"
          >
            <template slot="title">
              <div v-if="formData.classList.length > 0" class="appModelTitle">
                <span>{{ appDetailsDate }}</span>
                <span>
                  各应用使用时长详情（{{
                  formData.classList[classIndex].className
                  }}）
                </span>
              </div>
              <div v-else class="appModelTitle">各应用使用时长详情（全部班级）</div>
            </template>
            <div class="deviceDetails-table">
              <a-table
                bordered
                :rowKey="(record) => record.stuName"
                :locale="{
                  emptyText: '暂无数据',
                }"
                :columns="columns1"
                :scroll="{ x: true, y: 350 }"
                :data-source="appDurationTableInfo"
                :loading="appDurationTableLoading"
                :pagination="appDurationPage"
                @change="handleAppDurationTableChange"
              />
            </div>
          </a-modal>
          <a-modal
            v-model="modal2Visible"
            width="60%"
            centered
            :footer="null"
            @ok="() => (modal2Visible = false)"
          >
            <template slot="title">
              <div v-if="formData.classList.length > 0" class="appModelTitle">
                <span>{{ perCapitaDetailsDate }}</span>
                <span>
                  使用时长详情（{{
                  formData.classList[classIndex].className
                  }}）
                </span>
              </div>
              <div v-else class="appModelTitle">使用时长详情（全部班级）</div>
            </template>
            <div class="deviceDetails-table">
              <a-table
                bordered
                :rowKey="(record) => record.stuName + '_' + record.usedTime"
                :locale="{
                  emptyText: '暂无数据',
                }"
                :columns="columns2"
                :scroll="{ x: true, y: 350 }"
                :data-source="serviceDurationTableInfo"
                :loading="serviceDurationTableLoading"
                :pagination="serviceDurationPage"
                @change="handleServiceDurationTableChange"
              />
            </div>
          </a-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mTabbar from "../../../src/components/headTable"
import moment from "moment"
import Highcharts from "highcharts/highstock"
import Sortable from 'sortablejs'
let weeks = new Array(
  "星期日",
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六"
)
export default {
  data () {
    return {
      mTabbarType: true,
      noData: false,
      moment,
      currTab: "",
      tabs: [
        { name: "作业总况", id: 0, display: true },
        { name: "详细分析", id: 1, display: true },
        { name: "教学质量", id: 2, display: true },
        {
          name: "问卷调查",
          id: 3,
          display: this.$store.getters.orgid == 18 ? true : false,
        },
        {
          name: "设备详情",
          id: 4,
          display: true,
        },
      ],
      deviceDetailsInfo: {},
      getDeviceDetailsInfoParams: {
        weekOrMonth: 1 /* 按周或月查询:0：其他；1：前一周；2：前一月,默认是近一周 */,
        month: "",
        orgId: "",
        classId: "",
      },
      monthList: [],

      formData: {
        stageid: "0", // 当前学段
        gradeIds: "0", // 当前年级
        subjectId: "0", // 当前学科
        classid: "0", // 当前班级
        stageData: [], // 当前学段数据
        gradeList: [], // 当前年年级数据
        subjectsList: [], // 当前学科数据
        classList: [], // 当前班级列表
      },
      classlength: "",
      size: "0",
      isTrue: true,
      pageData: [],
      classIndex: 0,
      form: {
        startTime: "",
        endTime: "",
      },
      pagination: {},
      loadingTable: true,
      headList: {},
      analyseSize: "0",
      aveTime: {},
      timeConsuming: {},
      aveScore: {},
      activeSituationList: {}, //学生活跃情况数据
      deviceChartOptions: {
        chart: {
          type: "column",
        },
        title: {
          text: "学生活跃情况",
          align: "left",
          margin: 50,
        },
        subtitle: {
          text:
            "<p style='color:#333'><span style='color:#7cb5ec'>● 高频使用：</span>累计使用大于60分钟的人数</p>" +
            "<p style='color:#333'><span style='color:#90ed7d'>● 低频使用：</span>累计使用小于60分钟的人数</p>",
          useHTML: true,
          align: "right",
        },
        xAxis: {
          categories: [],
          crosshair: true,
        },
        credits: {
          enabled: false, //去除右下角的highCharts
        },
        exporting: {
          enabled: false, //去除左上角
        },
        yAxis: {
          min: 0,
          title: {
            text: "人数",
          },
        },
        tooltip: {
          formatter: function () {
            let tmp = ""
            let length = this.points.length //数据条数，this.points获取的是当前x轴刻度上的数据信息
            tmp += "<div class='custom-tooltip'>"
            for (let i = 0; i < length; i++) {
              let it = this.points[i]
              tmp +=
                "<p style='padding-right: 20px;'><span style='color:" +
                it.color +
                "'>● </span>" +
                "<span style='display:inline-block;vertical-align: middle;width:4em;text-overflow: ellipsis;white-space: nowrap; overflow: hidden;'>" +
                it.series.name +
                "</span>" +
                "：<span style='font-weight: bold'>" +
                it.y +
                " 人"
                ; ("</span></p>")
            }
            tmp += "</div>"
            return (
              "<div><span>" +
              this.x +
              " " +
              weeks[new Date(this.x).getDay()] +
              "</span>" +
              tmp +
              "</div>"
            )
          },
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          series: {
            animation: {
              duration: 1500,
            },
          },
          column: {
            pointPadding: 0,
            borderWidth: 0,
          },
        },
        colors: [
          "#7cb5ec",
          "#90ed7d",
          "#909399",
          "#f7a35c",
          "#8085e9",
          "#f15c80",
          "#e4d354",
          "#2b908f",
          "#f45b5b",
          "#91e8e1",
        ],

        series: [
          {
            id: 1,
            name: "高频使用",
            data: [],
          },
          {
            id: 2,
            name: "低频使用",
            data: [],
          },
          {
            id: 3,
            name: "未使用",
            data: [],
          },
        ],
      },
      serviceDurationInfo: {}, //用户人均使用时长数据
      networkMonitoringOptions: {
        chart: {
          type: "spline",
          zoomType: "x",
        },
        title: {
          text: "人均使用时长",
          align: "left",
          margin: 50,
        },
        // tooltip: {
        //   crosshairs: true,
        //   shared: true,
        //   useHTML: true, //是否使用HTML编辑提示信息
        //   footerFormat:
        //     "<div style='text-align:center;padding-top: 5px'><span class='btn-two green rounded perCapitaDetails'>详情</span></div>",
        //   style: {
        //     pointerEvents: "all",
        //   },
        // },
        tooltip: {
          shared: true,
          useHTML: true,
          style: {
            pointerEvents: "all",
          },
          formatter: function () {
            let tmp = ""
            let length = this.points.length //数据条数，this.points获取的是当前x轴刻度上的数据信息

            let rowCount = 8 //一列允许的最大行数
            let count = parseInt(length / rowCount) + 1 //列数
            tmp += "<table>"
            for (let i = 0; i < rowCount; i++) {
              tmp += "<tr>"
              for (let j = 0; j < count && i * count + j < length; j++) {
                let it = this.points[i + j * count]
                tmp +=
                  "<td style='padding-right: 20px'><span style='color:" +
                  it.color +
                  "'>● </span>" +
                  it.series.name +
                  ":<span style='font-weight: bold'>" +
                  Highcharts.dateFormat("%H小时%M分钟", it.y * 60 * 1000)
                  ; ("</span></td>")
              }
              tmp += "</tr>"
            }
            tmp += "</table>"
            return (
              "<div><span>" +
              this.x +
              " " +
              weeks[new Date(this.x).getDay()] +
              "</span>" +
              tmp +
              "<span class='btn-two green rounded perCapitaDetails' date=" +
              this.x +
              " >详情</span></div>"
            )
          },
        },
        legend: {
          enabled: false, //  禁用图例
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: "时长/分钟",
          },
          min: 0,
        },
        plotOptions: {
          area: {
            fillColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1,
              },
              stops: [
                [0, new Highcharts.getOptions().colors[0]],
                [
                  1,
                  new Highcharts.Color(Highcharts.getOptions().colors[0])
                    .setOpacity(0)
                    .get("rgba"),
                ],
              ],
            },
            marker: {
              radius: 2,
            },
            lineWidth: 1,
            states: {
              hover: {
                lineWidth: 1,
              },
            },
            threshold: null,
          },
          series: {
            animation: {
              duration: 1500,
            },
          },
        },
        series: [
          {
            id: 1,
            type: "area",
            name: "人均使用时长",
            color: "rgb(81, 130, 228)",
            marker: {
              enabled: false /*数据点是否显示*/,
              radius: 5 /*数据点大小px*/,
              // fillColor: '#ff3300' /*数据点颜色*/,
              lineWidth: 6,
            },
            tooltip: {
              valueSuffix: "分钟",
            },
            data: [],
          },
        ],
      },
      serviceDurationPage: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`, //分页中显示总的数据
      },
      perCapitaDetailsDate: "",
      serviceDurationTableInfo: [],
      // 各应用人均使用时长数据
      appDurationInfo: {},
      appDurationOptions: {
        title: {
          text: "各应用人均使用时长",
          align: "left",
          margin: 50,
        },
        xAxis: {
          categories: [],
          crosshair: true,
        },
        yAxis: {
          title: {
            text: "时长/分钟",
          },
        },
        // tooltip: {
        //   crosshairs: true,
        //   shared: true,
        //   useHTML: true, //是否使用HTML编辑提示信息
        //   footerFormat:
        //     "<div style='text-align:center;padding-top: 5px'><span class='btn-two green rounded appDetails'>详情</span></div>",
        //   style: {
        //     pointerEvents: "all",
        //   },
        //   positioner: function(labelWidth, labelHeight, point) {
        //     return { x: point.plotX, y: point.plotY - 20 }
        //   },
        // },
        tooltip: {
          shared: true,
          useHTML: true,
          style: {
            pointerEvents: "all",
          },

          formatter: function () {
            let tmp = ""
            let length = this.points.length //数据条数，this.points获取的是当前x轴刻度上的数据信息
            tmp += "<div class='custom-tooltip'>"
            for (let i = 0; i < length; i++) {
              let it = this.points[i]
              tmp +=
                "<p style='padding-right: 20px;'><span style='color:" +
                it.color +
                "'>● </span>" +
                "<span style='display:inline-block;vertical-align: middle;width:4em;text-overflow: ellipsis;white-space: nowrap; overflow: hidden;'>" +
                it.series.name +
                "</span>" +
                "：<span style='font-weight: bold'>" +
                Highcharts.dateFormat("%H小时%M分钟", it.y * 60 * 1000)
                ; ("</span></p>")
            }
            tmp += "</div>"
            return (
              "<div><span>" +
              this.x +
              " " +
              weeks[new Date(this.x).getDay()] +
              "</span>" +
              tmp +
              "<span class='btn-two green rounded appDetails' date=" +
              this.x +
              ">详情</span></div>"
            )
          },

          positioner: function (labelWidth, labelHeight, point) {
            let offsetX = labelWidth / 7
            let offsetY = labelHeight / 4
            if (point.plotY < 80) {
              offsetY = -labelWidth / 8
            } else if (point.plotY > 200) {
              offsetY = labelWidth / 4
            }

            if (point.plotX < 160) {
              offsetX = labelWidth / 12
            }
            return { x: point.plotX - offsetX, y: point.plotY - offsetY }
          },
        },
        credits: {
          enabled: false, //去除右下角的highCharts
        },
        exporting: {
          enabled: false, //去除左上角
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            animation: {
              duration: 1500,
            },
            label: {
              connectorAllowed: false,
            },
          },
        },
        series: [],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
      },
      spinning: false,
      appDurationTableInfo: [],
      appDurationPage: {
        current: 1,
        pageSize: 10,
        defaultCurrent: 1,
        showTotal: (total) => `共 ${total} 条`, //分页中显示总的数据
      },
      appDetailsDate: "", // 当前选中的时间
      modal1Visible: false,
      modal2Visible: false,
      appTypeList: [],
      appDurationTableLoading: false,
      serviceDurationTableLoading: false,
      columns1: [
        {
          title: "学生姓名",
          dataIndex: "stuName",
          align: "center",
          width: 150,
        },
      ],
      columns2: [
        {
          title: "学生姓名",
          dataIndex: "stuName",
          align: "center",
          width: 150,
        },
        {
          title: "平板使用时长",
          dataIndex: "usedTime",
          align: "center",
          sorter: true,
          width: 150,
          customRender: (text, record, index) => {
            return this.formatTime(text)
          },
        },
      ],
      cakeNo: true,
      dataSource: [],
      columns: [
        {
          title: "作业标题",
          dataIndex: "name",
          key: "name",
          align: "center",
          width: 200,
        },
        {
          title: "学科",
          dataIndex: "subjectName",
          key: "subjectName",
          align: "center",
          width: 110,
        },
        {
          title: "老师",
          dataIndex: "teacherName",
          key: "teacherName",
          align: "center",
          width: 100,
        },
        {
          title: "发布时间",
          dataIndex: "pushdate",
          key: "pushdate",
          align: "center",
          width: 150,
        },
        {
          title: "提交人数",
          // dataIndex: 'submit',
          key: "submit",
          scopedSlots: { customRender: "submit" },
          align: "center",
          width: 100,
        },
        {
          // title: '得分率',
          slots: { title: "scoreRate" },
          key: "scoreRate",
          scopedSlots: { customRender: "scoreRate" },
          align: "center",
          width: 80,
        },
        {
          key: "correctRate",
          slots: { title: "correctRate" },
          scopedSlots: { customRender: "correctRate" },
          align: "center",
          width: 80,
        },
        {
          key: "revisionCorrectRate",
          scopedSlots: { customRender: "revisionCorrectRate" },
          slots: { title: "revisionCorrectRate" },
          align: "center",
          width: 100,
        },
        {
          // title: '订正人数',
          dataIndex: "revisionwrong",
          key: "revisionwrong",
          slots: { title: "revisionwrong" },
          align: "center",
          width: 100,
        },

        // {
        //   // title: '完对率',
        //   slots: { title: "rightRate" },
        //   key: "rightRate",
        //   scopedSlots: { customRender: "rightRate" },
        //   align: "center",
        //   width: 80,
        // },
        {
          dataIndex: "outstandingRate",
          key: "outstandingRate",
          slots: { title: "outstandingRate" },
          align: "center",
          width: 80,
        },
        {
          dataIndex: "failRate",
          key: "failRate",
          slots: { title: "failRate" },
          align: "center",
          width: 90,
        },
        {
          title: "微课数",
          dataIndex: "explaincounts",
          key: "explaincounts",
          align: "center",
          width: 80,
        },
        {
          title: "微课时长",
          dataIndex: "microlessontime",
          key: "microlessontime",
          align: "center",
          width: 90,
        },
      ],
      submitArr: [],
      arrTime: [],
      // 详细分析
      teacherList: [],
      loadingTeach: true,
      classData: [],
      getColor (val, index) {
        if (index == 1) {
          if (90 <= val && val < 100) {
            return "orange"
          } else if (val < 90) {
            return "red"
          }
        } else if (index == 2) {
          if (val >= 80) {
            return "green"
          } else if (50 <= val && val < 80) {
            return "orange"
          } else if (val < 50) {
            return "red"
          }
        } else if (index == 3) {
          if (val >= 90) {
            return "green"
          } else if (50 <= val && val < 90) {
            return "orange"
          } else if (val < 50) {
            return "red"
          }
        } else if (index == 4) {
          if (val >= 80) {
            return "green"
          } else if (60 <= val && val < 80) {
            return "orange"
          } else if (val < 60) {
            return "red"
          }
        }
      },
      getColorStyle (item,index,title) {
        if(title == '老师'){
          return "colorName"
        }else if(item.toString().search("%") != -1){
          let val=item.replace('%', '')
          if(index == 5){
            // 平均得分率
            if (val >= 80) {
              return "green"
            } else if (50 <= val && val < 80) {
              return "orange"
            } else if (val < 50) {
              return "red"
            }
          }else if(index == 6){
            if (90 <= val && val < 100) {
              return "orange"
            } else if (val < 90) {
              return "red"
            }
          }
        }
      },
      // 教学质量
      knowledgeList: [],
      knowpage: {
        page: 1,
        pageSize: 30,
        rowCount: 0,
      },
      loadingList: true,
      // 问卷调查
      quesnairtData: [],
      quesnairtStu: "",
      stuSuggestionList: [],
      naircolumns: [
        {
          title: "姓名",
          dataIndex: "stuName",
          key: "stuName",
          width: 180,
        },
        {
          title: "文本答案",
          dataIndex: "suggestion",
          key: "suggestion",
        },
      ],
      subjectName:'全部',
      teacherAnalyse:[
        {
          id:0,
          title:'学科',
          tips:null,
          data:[],
          isCheck:true,
        },
        {
          id:1,
          title:'老师',
          tips:null,
          data:[],
          isCheck:true,
        },
        {
          id:2,
          title:'任课班级',
          tips:null,
          data:[],
          isCheck:true,
        },
        {
          id:3,
          title:'布置次数',
          tips:null,
          data:[],
          isCheck:true,
        },
        {
          id:4,
          title:'主观题/总题量',
          tips:null,
          data:[],
          isCheck:true,
        },
        {
          id:5,
          title:'平均得分率',
          tips:'(每次作业的全部学生得分之和)/ <br/> [(每次作业总分*已批改人数)之和]* 100%',
          data:[],
          isCheck:true,
        },
        {
          id:6,
          title:'平均批改率',
          tips:'（已批改的总人数）/（提交作业的总人数）* 100% ',
          data:[],
          isCheck:true,
        },
        {
          id:7,
          title:'订正批改率',
          tips:'（已批改的订正人数）/（提交订正的人数）* 100%  ',
          data:[],
          isCheck:true,
        },
        {
          id:8,
          title:'订正人次',
          tips:'n / m，n表示每次作业提交订正的人次之和，<br/>m表示每次作业错题人次之和',
          data:[],
          isCheck:true,
        },
        {
          id:9,
          title:'平均订正率',
          tips:'每次作业的学生作业订正率取平均<br/>学生作业订正率=（有过订正的试题数量/错题总数）* 100% ',
          data:[],
          isCheck:true,
        },
        // {
        //   id:10,
        //   title:'平均完对率',
        //   tips:'（每次作业的各题正确人次之和）/<br/> [(每次作业题数*已批改人数)之和]* 100% ',
        //   data:[],
        //   isCheck:true,
        // },
        {
          id:10,
          title:'微课数',
          tips:null,
          data:[],
          isCheck:true,
        },
        {
          id:11,
          title:'微课总时长',
          tips:null,
          data:[],
          isCheck:true,
        }
      ],
      copyTeacherAnalyse:[],
      classAnalyse:[
        {
          id:0,
          title:'班级',
          tips:null,
          data:[],
          isCheck:true,
        },
        {
          id:1,
          title:'学科',
          tips:null,
          data:[],
          isCheck:true,
        },
        {
          id:2,
          title:'老师',
          tips:null,
          data:[],
          isCheck:true,
        },
        {
          id:3,
          title:'布置次数',
          tips:null,
          data:[],
          isCheck:true,
        },
        {
          id:4,
          title:'平均每次题量',
          tips:null,
          data:[],
          isCheck:true,
        },
        {
          id:5,
          title:'得分率',
          tips:'（每次作业的全部学生得分之和）/<br/> [(每次作业总分*已批改人数)之和]* 100%',
          data:[],
          isCheck:true,
        },
        {
          id:6,
          title:'批改率',
          tips:'已批改的学生数/提交作业的人数* 100%',
          data:[],
          isCheck:true,
        },
        {
          id:7,
          title:'订正批改率',
          tips:'（已批改的订正人数）/（提交订正的人数）* 100% ',
          data:[],
          isCheck:true,
        },
        {
          id:8,
          title:'订正人次',
          tips:' n / m，n表示每次作业提交订正的人次之和<br/>，m表示每次作业错题人次之和',
          data:[],
          isCheck:true,
        },
        {
          id:9,
          title:'订正率',
          tips:'(每次作业错题的订正题次之和)/(错题总人次)* 100%',
          data:[],
          isCheck:true,
        },
        // {
        //   id:10,
        //   title:'完对率',
        //   tips:'（每次作业的各题正确人次之和）/<br/> [(每次作业题数*已批改人数)之和]* 100%',
        //   data:[],
        //   isCheck:true,
        // },
        {
          id:10,
          title:'人均每次用时',
          tips:null,
          data:[],
          isCheck:true,
        },
        {
          id:11,
          title:'微课数',
          tips:null,
          data:[],
          isCheck:true,
        },
        {
          id:12,
          title:'微课总时长',
          tips:null,
          data:[],
          isCheck:true,
        },
      ],
      copyClassAnalyse:[],
      showCheckbox:false,//选择框是否显示
      classShowCheckbox:false,//选择框是否显示
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    // 学段学科年级班级
    getAlllinkage () {
      this.formData.classList = []
      this.formData.stageData = []
      this.formData.gradeList = []
      this.formData.subjectsList = []
      this.$http
        .get("v1/learnonly/teachingAssistant/getSubjectByGrade", {
          params: { userid: this.$store.getters.id },
        })
        .then((res) => {
          var data = res.data.data
          data.sort(function (a, b) {
            return a.stageid - b.stageid
          })
          data.forEach((i) => {
            i.gradesLists.sort(function (a, b) {
              return a.gradeIds - b.gradeIds
            })
            var xd = i
            this.formData.stageData.push(xd)
            i.gradesLists.forEach((j) => {
              // j.classLists.sort(function (a, b) {
              //   return a.classid - b.classid
              // })
              var nj = j
              this.formData.gradeList.push(nj)
              j.classLists.forEach((k) => {
                this.formData.classList.push(k)
              })
            })
            i.subjectsLists.forEach((m) => {
              if (m.subjectName) {
                var xk = {
                  subjectId: m.subjectId,
                  subjectName: i.stageName + m.subjectName,
                  stageid: i.stageid,
                }
                this.formData.subjectsList.push(xk)
              }
            })
          })
          this.$nextTick(() => {
            if (
              this.formData.classList.length > 0 &&
              this.formData.classList[0].classid != 0
            ) {
              this.formData.classList.unshift({
                className: "全部班级",
                classid: 0,
              })
            } else {
              this.formData.classList.unshift({
                className: "全部班级",
                classid: 0,
              })
            }
            this.classlength = this.formData.classList.length
            this.pageData = data
          })
        })
    },
    getNewFormData () {
      var data = this.pageData
      this.pageData = []
      this.formData.classList = []
      this.formData.stageData = []
      this.formData.gradeList = []
      this.formData.subjectsList = []
      data.forEach((i) => {
        i.gradesLists.forEach((j) => {
          var nj = { gradeIds: j.gradeIds, gradeName: j.gradeName }
          this.formData.gradeList.push(nj)

          j.classLists.forEach((k) => {
            this.formData.classList.push(k)
          })
        })
        i.subjectsLists.forEach((m) => {
          if (m.subjectName) {
            var xk = {
              subjectId: m.subjectId,
              subjectName: i.stageName + m.subjectName,
            }
            this.formData.subjectsList.push(xk)
          }
        })
      })
    },
    // 按钮筛选调用公共方法
    commonGet () {
      if (this.currTab == 0) {
        this.$nextTick(() => {
          this.getHeadData()
          this.getLineChart()
          this.getPieChart()
          this.getAllexerciseTable()
        })
      } else if (this.currTab == 1) {
        this.$nextTick(() => {
          this.getTeacheranalyse()
          //this.getAllexerciseTable()
        })
      } else if (this.currTab == 2) {
        this.$nextTick(() => {
          this.getKnowanalyse()
        })
      } else {
        if (this.currTab == 4) {
          this.spinning = true
          this.getDeviceDetailsInfo()
          this.getActiveSituation()
          this.getServiceDuration()
          this.getAppDurationInfo()
        } else {
          this.$nextTick(() => {
            this.getQuesnair()
          })
        }
      }
    },
    // 类型筛选
    selectTab (index) {
      this.currTab = index
      if (this.pagination.current != undefined) {
        this.pagination.current = 1
      }
      this.classIndex = this.classIndex
      this.$nextTick(() => {
        this.commonGet()
      })
    },
    // 时间筛选
    TimeChange (event) {
      if (this.pagination.current != undefined) {
        this.pagination.current = 1
      }
      this.size = event
      if (this.size == 2) {
        if (this.isTrue) {
          this.form.startTime = moment(
            new Date().getFullYear() + "/02/01"
          ).format("YYYY-MM-DD")
          this.form.endTime = moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD")
        } else {
          var beginDate = new Date(new Date().getFullYear() + "/01/01"),
            endDate = new Date(new Date().getFullYear() + "/02/01")
          if (new Date() >= beginDate && new Date() <= endDate) {
            this.form.startTime = moment(
              new Date().getFullYear() - 1 + "/09/01"
            ).format("YYYY-MM-DD")
          } else {
            this.form.startTime = moment(
              new Date().getFullYear() + "/09/01"
            ).format("YYYY-MM-DD")
          }
          this.form.endTime = moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD")
        }
      } else if (this.size == 1) {
        this.form.startTime = moment(new Date())
          .subtract(1, "months")
          .format("YYYY-MM-DD")
        this.form.endTime = moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD")
      } else {
        this.form.startTime = moment(new Date())
          .subtract(1, "weeks")
          .format("YYYY-MM-DD")
        this.form.endTime = moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD")
      }
      this.$nextTick(() => {
        this.commonGet()
      })
    },
    // 时间
    disabledDate (current) {
      return current && current > moment(new Date()).add(-1, "days")
    },
    onChangeTime (date, dateString) {
      if (this.pagination.current != undefined) {
        this.pagination.current = 1
      }
      this.form.startTime = dateString[0]
      this.form.endTime = dateString[1]
      this.size = ""
      this.$nextTick(() => {
        this.commonGet()
      })
    },
    // 选择学段
    changeStage (item) {
      this.subjectName='全部'
      if (this.pagination.current != undefined) {
        this.pagination.current = 1
      }
      this.classIndex = "0"
      if (item != "0") {
        this.formData.gradeIds = "0"
        this.formData.subjectId = "0"
        this.formData.classList = []
        this.formData.stageid = item.stageid
        this.formData.gradeList = item.gradesLists
        this.formData.subjectsList = item.subjectsLists
        this.formData.gradeList.forEach((m) => {
          m.classLists.forEach((n) => {
            this.formData.classList.push(n)
          })
        })
        if (this.formData.classList[0].classid != 0) {
          this.formData.classList.unshift({
            className: "全部班级",
            classid: 0,
          })
        }
        this.$nextTick(() => {
          this.commonGet()
        })
      } else {
        this.formData.stageid = "0"
        this.formData.gradeIds = "0"
        this.formData.subjectId = "0"
        this.formData.classid = "0"
        this.getAlllinkage()
        this.$nextTick(() => {
          this.commonGet()
        })
      }
    },
    // 选择年级
    changeGrade (item) {
      if (this.pagination.current != undefined) {
        this.pagination.current = 1
      }
      this.classIndex = 0
      if (item != "0") {
        // this.formData.subjectId = "0"
        this.formData.classList = []
        this.pageData.forEach((i) => {
          i.gradesLists.forEach((j) => {
            if (j.gradeIds == item.gradeIds) {
              this.formData.stageid = i.stageid
              this.formData.subjectsList = i.subjectsLists
            }
          })
        })
        this.formData.gradeIds = item.gradeIds
        if (item.classLists[0].classid != 0) {
          item.classLists.unshift({
            className: "全部班级",
            classid: 0,
          })
        }
        this.$nextTick(() => {
          this.formData.classList = item.classLists
          this.formData.classid = this.formData.classList[0].classid
        })
        this.$nextTick(() => {
          this.commonGet()
        })
      } else {
        this.formData.stageid = "0"
        this.formData.gradeIds = "0"
        this.formData.classid = "0"
        // this.getAlllinkage()
        this.$nextTick(() => {
          this.commonGet()
        })
      }
    },
    // 选择学科
    changeSubjects (item) {
      this.subjectName=item.subjectName
      if (this.pagination.current != undefined) {
        this.pagination.current = 1
      }
      if (item != "0") {
        if (item.stageid != undefined) {
          this.formData.stageid = item.stageid
        }
        this.formData.subjectId = item.subjectId
        this.$nextTick(() => {
          this.commonGet()
        })
      } else {
        this.formData.subjectId=0
        this.$nextTick(() => {
          this.commonGet()
        })
      }
    },
    // 选择班级
    selectClass (item, index) {
      if (this.spinning)
        return this.$message.warning("正在加载数据,请稍后...", 1)
      this.classIndex = index
      if (this.pagination.current != undefined) {
        this.pagination.current = 1
      }
      if (this.formData.classList.length == this.classlength) {
        this.formData.stageid = "0"
        this.formData.gradeIds = "0"
      }
      this.pageData.forEach((i) => {
        i.gradesLists.forEach((j) => {
          j.classLists.forEach((k) => {
            if (k.classid == item.classid) {
              this.formData.stageid = i.stageid
              this.formData.gradeIds = j.gradeIds
            }
          })
        })
      })
      this.formData.subjectId = "0"
      this.formData.classid = item.classid
      for (let i = 0; i < this.pageData.length; i++) {
        if (this.formData.stageid == this.pageData[i].stageid) {
          this.formData.subjectsList = this.pageData[i].subjectsLists
        }
      }
      this.$nextTick(() => {
        this.commonGet()
        $("html, body").animate({ scrollTop: 0 }, 0)
      })
    },
    // 获取汇总数量
    getHeadData () {
      this.$http
        .get("/v1/learnonly/aianalyse/v2/headmasterdata", {
          params: {
            // orgid: 36,
            orgid: this.$store.getters.orgid,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            stageid: this.formData.stageid,
            gradeid: this.formData.gradeIds,
            subjectid: this.formData.subjectId,
            classid: this.formData.classid,
            // classid: this.formData.classid == 287 ? 232 : 233,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.headList = res.data.data
            var TimingMap = res.data.data.aveTimingMap
            var timeData = []
            this.arrTime = []
            for (let [k, i] of Object.entries(TimingMap)) {
              var minute = i / (1000 * 60)
              i = +minute.toFixed(2)
              if (k) timeData.unshift(k)
              this.arrTime.unshift(i)
            }
            this.timeConsuming = {
              chart: {
                type: "spline",
                backgroundColor: "#fff",
                boxSecond: "#24263e",
              },
              title: {
                text: "",
                style: {
                  color: "#333",
                },
              },
              legend: {
                enabled: false, //  禁用图例
              },
              credits: {
                enabled: false,
              },
              xAxis: {
                categories: timeData,
                labels: {
                  formatter: function () {
                    return this.value
                  },
                },
              },
              yAxis: {
                title: {
                  text: "时间（分钟）",
                },
                labels: {
                  formatter: function () {
                    return this.value
                  },
                },
              },
              series: [
                {
                  name: "人均用时",
                  color: "rgb(81, 130, 228)",
                  marker: {
                    enabled: false /*数据点是否显示*/,
                    radius: 5 /*数据点大小px*/,
                    //fillColor:'#ff3300'         /*数据点颜色*/
                    lineWidth: 6,
                  },
                  tooltip: {
                    valueSuffix: "分钟",
                  },
                  data: this.arrTime,
                },
              ],
            }
          }
        })
    },
    // 作业提交时间分布折线图
    getLineChart () {
      this.$http
        .get("/v1/learnonly/aianalyse/timeDistribution", {
          params: {
            // orgid: 36,
            orgid: this.$store.getters.orgid,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            stageid: this.formData.stageid,
            gradeid: this.formData.gradeIds,
            subjectid: this.formData.subjectId,
            // classid: this.formData.classid == 287 ? 232 : 233,
            classid: this.formData.classid,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.submitArr = res.data.data
            var data = res.data.data
            var arrHour = []
            var arrPercent = []
            for (let i = 0; i < data.length; i++) {
              arrHour.push(data[i].hour + ":00")
              arrPercent.push(data[i].percent)
            }
            this.aveTime = {
              chart: {
                type: "spline",
                zoomType: "x",
                //     backgroundColor: '#fff',
                //     boxSecond: '#24263e',
              },
              title: {
                text: "",
                //     style: {
                //       color: '#333',
                //     },
              },
              legend: {
                enabled: false, //  禁用图例
              },
              credits: {
                enabled: false,
              },
              xAxis: {
                categories: arrHour,
                labels: {
                  style: {
                    // color: 'rgba(255,255,255,0.5)',
                  },
                },
              },
              yAxis: {
                title: {
                  text: "比例（%）",
                },
                min: 0,
              },
              plotOptions: {
                area: {
                  fillColor: {
                    linearGradient: {
                      x1: 0,
                      y1: 0,
                      x2: 0,
                      y2: 1,
                    },
                    stops: [
                      [0, new Highcharts.getOptions().colors[0]],
                      [
                        1,
                        new Highcharts.Color(Highcharts.getOptions().colors[0])
                          .setOpacity(0)
                          .get("rgba"),
                      ],
                    ],
                  },
                  marker: {
                    radius: 2,
                  },
                  lineWidth: 1,
                  states: {
                    hover: {
                      lineWidth: 1,
                    },
                  },
                  threshold: null,
                },
              },
              series: [
                {
                  type: "area",
                  name: "提交比例",
                  color: "rgb(81, 130, 228)",
                  marker: {
                    enabled: false /*数据点是否显示*/,
                    radius: 5 /*数据点大小px*/,
                    // fillColor: '#ff3300' /*数据点颜色*/,
                    lineWidth: 6,
                  },
                  tooltip: {
                    valueSuffix: "%",
                  },
                  data: arrPercent,
                },
              ],
            }
          }
        })
    },
    // 学生成绩等级分布饼图
    getPieChart () {
      this.$http
        .get("v1/learnonly/aianalyse/scoreDistribution", {
          params: {
            // orgid: 36,
            orgid: this.$store.getters.orgid,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            stageid: this.formData.stageid,
            gradeid: this.formData.gradeIds,
            subjectid: this.formData.subjectId,
            // classid: this.formData.classid == 287 ? 232 : 233,
            classid: this.formData.classid,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            var data = res.data.data.score
            var score = []
            var arrNodata = []
            if (!data) return
            for (let i = 0; i < data.length; i++) {
              if (data[i].num != 0) {
                arrNodata.push(true)
              }
            }
            if (arrNodata.length != 0) {
              this.cakeNo = true
              for (let i = 0; i < data.length; i++) {
                if (data[i].level == 1) {
                  data[i].levelName = "优秀(85-100%)："
                } else if (data[i].level == 2) {
                  data[i].levelName = "良好(70-85%)："
                } else if (data[i].level == 3) {
                  data[i].levelName = "合格(60-70%)："
                } else if (data[i].level == 4) {
                  data[i].levelName = "不及格(低于60%)："
                }
                if (data[i].classScoreDistributionList == undefined) {
                  score.push({
                    name: data[i].levelName,
                    y: data[i].num,
                  })
                } else {
                  for (
                    let j = 0;
                    j < data[i].classScoreDistributionList.length;
                    j++
                  ) {
                    var sum = 0
                    var total = 0
                    for (
                      let k = 0;
                      k < data[i].classScoreDistributionList[j].length;
                      k++
                    ) {
                      sum += data[i].classScoreDistributionList[j][k].num
                      total = parseFloat(
                        parseFloat(
                          sum / data[i].classScoreDistributionList[j].length
                        ).toFixed()
                      )
                    }
                    data[i].classScoreDistributionList[j].unshift({
                      className: "年级平均",
                      num: total,
                    })
                    score.push({
                      name: data[i].levelName,
                      y: data[i].num,
                      data: data[i].classScoreDistributionList[j],
                    })
                  }
                }
              }
              // console.log(score)
              var clickClassid = this.formData.classid
              // 环形图
              this.aveScore = {
                chart: {
                  spacing: [40, 0, 40, 0],
                  style: {
                    fontSize: "14px",
                  },
                },
                title: {
                  text: "",
                },
                colors: [
                  "rgb(59, 182, 7)",
                  "rgb(144, 237, 125)",
                  "rgb(247, 163, 92)",
                  "#DF212B",
                ],
                tooltip: {
                  formatter: function () {
                    if (this.point.data != undefined) {
                      var s = ""
                      for (let i = 0; i < this.point.data.length; i++) {
                        if (
                          this.point.data[i].classid == clickClassid ||
                          this.point.data[i].classid == undefined
                        ) {
                          s +=
                            '<br /><b style="font-size: 16px;font-weight:bold">' +
                            this.point.data[i].className +
                            ":" +
                            this.point.data[i].num +
                            "人</b>"
                        } else {
                          s +=
                            '<br /><b style="font-size: 12px;">' +
                            this.point.data[i].className +
                            ":" +
                            this.point.data[i].num +
                            "人</b>"
                        }
                      }
                      return s
                    } else {
                      return this.key + this.y + "人"
                    }
                  },
                },
                credits: {
                  enabled: false, //不显示LOGO
                },
                series: [
                  {
                    type: "pie",
                    innerSize: "80%",
                    name: "",
                    data: score,
                  },
                ],
              }
            } else {
              this.cakeNo = false
            }
          }
        })
    },
    // 全部作业表格
    getAllexerciseTable () {
      this.loadingTable = true
      this.$http
        .get("/v1/learnonly/aianalyse/master/allexercise", {
          params: {
            // orgid: 36,
            orgid: this.$store.getters.orgid,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            stageid: this.formData.stageid,
            gradeid: this.formData.gradeIds,
            subjectid: this.formData.subjectId,
            // classid: this.formData.classid == 287 ? 232 : 233,
            classid: this.formData.classid,
            teacherid: 0,
            page: this.pagination.current ? this.pagination.current : 1,
            size: 20,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.loadingTable = false
            this.dataSource = res.data.data.data
            for (let i = 0; i < this.dataSource.length; i++) {
              // 杜亚泉教师姓名处理
              // this.dataSource[i].teacherName = this.fixTeaname(
              //   this.dataSource[i].teacherName
              // )
              // 提交人数
              this.dataSource[i].submit =
                this.dataSource[i].submitcount +
                "/" +
                this.dataSource[i].studentcount
              // 订正人数
              this.dataSource[i].revisionwrong =
                this.dataSource[i].revisionstudentcount +
                "/" +
                this.dataSource[i].wrongquesnum
              // 优秀率
              this.dataSource[i].outstandingRate =
                parseFloat(
                  parseFloat(this.dataSource[i].outstandingRate).toFixed(2)
                ) + "%"
              // 不及格率
              this.dataSource[i].failRate =
                parseFloat(parseFloat(this.dataSource[i].failRate).toFixed(2)) +
                "%"
              // 微课数
              this.dataSource[i].explaincounts == 0
                ? (this.dataSource[i].explaincounts = "/")
                : this.dataSource[i].explaincounts
              // 微课时长
              if (this.dataSource[i].microlessontime == 0) {
                this.dataSource[i].microlessontime = "/"
              } else {
                var min = Math.floor(
                  (this.dataSource[i].microlessontime / 1000 / 60) << 0
                )
                var sec = Math.floor(
                  (this.dataSource[i].microlessontime / 1000) % 60
                )
                this.dataSource[i].microlessontime = min + "分" + sec + "秒"
              }
            }
            const pagination = { ...this.pagination }
            pagination.total = res.data.data.length
            pagination.pageSize = 20
            this.pagination = pagination
          } else {
            this.loadingTable = false
            this.dataSource = []
            this.pagination = false
          }
        })
    },
    numberParseFloat (num) {
      if (num == undefined) {
        return "0"
      } else {
        var val = parseFloat(num).toFixed(2)
        return parseFloat(val)
      }
    },
    timems2min (ms) {
      if (ms) {
        var min = Math.floor((ms / 1000 / 60) << 0)
        var sec = Math.floor((ms / 1000) % 60)
        return min + "分" + sec + "秒"
      } else {
        return "/"
      }
    },
    // 详细分析接口
    getTeacheranalyse () {
      this.loadingTeach = true
      this.$http
        .get("/v1/learnonly/aianalyse/v2/teacheranalyse", {
          params: {
            // orgid: 36,
            orgid: this.$store.getters.orgid,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            stageid: this.formData.stageid,
            gradeid: this.formData.gradeIds,
            subjectid: this.formData.subjectId,
            // classid: this.formData.classid == 287 ? 232 : 233,
            classid: this.formData.classid,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.loadingTeach = false
            this.teacherList = res.data.data.bankData
            this.classData = res.data.data.classData
            this.teacherAnalyse.forEach((k)=>{
              k.data=[]
            })
            this.classAnalyse.forEach((k)=>{
              k.data=[]
            })
            if(this.teacherList.length != 0){
              // 数据重组
              this.teacherList.forEach((item)=>{
                for(let i=0;i<item.analyseBankDataMessageList.length;i++){
                  this.teacherAnalyse[0].data.push({'value':item.bankName})
                  this.teacherAnalyse[1].data.push({'value':item.analyseBankDataMessageList[i].teacherName,'teacherid':item.analyseBankDataMessageList[i].teacherid})
                  this.teacherAnalyse[2].data.push({'value':item.analyseBankDataMessageList[i].classnum})
                  this.teacherAnalyse[3].data.push({'value':item.analyseBankDataMessageList[i].exercisecount})
                  this.teacherAnalyse[4].data.push({'value':item.analyseBankDataMessageList[i].subjectquescount+' | '+item.analyseBankDataMessageList[i].quescount})
                  this.teacherAnalyse[5].data.push({'value':this.numberParseFloat(item.analyseBankDataMessageList[i].scoreRate)+'%'})
                  this.teacherAnalyse[6].data.push({'value':this.numberParseFloat(item.analyseBankDataMessageList[i].correctRate)+'%'})
                  this.teacherAnalyse[7].data.push({'value':this.numberParseFloat(item.analyseBankDataMessageList[i].revisionCorrectRate)+'%'})
                  this.teacherAnalyse[8].data.push({'value':item.analyseBankDataMessageList[i].revisionstudentcount+' | '+item.analyseBankDataMessageList[i].wrongquescount})
                  this.teacherAnalyse[9].data.push({'value':this.numberParseFloat(item.analyseBankDataMessageList[i].revisionRateByQues)+'%'})
                  //this.teacherAnalyse[10].data.push({'value':this.numberParseFloat(item.analyseBankDataMessageList[i].rightRate)+'%'})
                  this.teacherAnalyse[10].data.push({'value':item.analyseBankDataMessageList[i].microlessoncount})
                  this.teacherAnalyse[11].data.push({'value':this.timems2min(item.analyseBankDataMessageList[i].microlessontime)})
                }
              })
              this.copyTeacherAnalyse=this.teacherAnalyse
            }
            if(this.classData.length != 0){
              // 数据重组
              this.classData.forEach((item)=>{
                for(let i=0;i<item.analyseBankDataMessageList.length;i++){
                  this.classAnalyse[0].data.push({'value':item.className})
                  this.classAnalyse[1].data.push({'value':item.analyseBankDataMessageList[i].bankName})
                  this.classAnalyse[2].data.push({'value':item.analyseBankDataMessageList[i].teacherName,'teacherid':item.analyseBankDataMessageList[i].teacherid})
                  this.classAnalyse[3].data.push({'value':item.analyseBankDataMessageList[i].exercisecount})
                  this.classAnalyse[4].data.push({'value':(item.analyseBankDataMessageList[i].quescount/item.analyseBankDataMessageList[i].exercisecount).toFixed(2)})
                  this.classAnalyse[5].data.push({'value':this.numberParseFloat(item.analyseBankDataMessageList[i].scoreRate)+'%'})
                  this.classAnalyse[6].data.push({'value':this.numberParseFloat(item.analyseBankDataMessageList[i].correctRate)+'%'})
                  this.classAnalyse[7].data.push({'value':this.numberParseFloat(item.analyseBankDataMessageList[i].revisionCorrectRate)+'%'})
                  this.classAnalyse[8].data.push({'value':item.analyseBankDataMessageList[i].revisionstudentcount+' | '+item.analyseBankDataMessageList[i].wrongquescount})
                  this.classAnalyse[9].data.push({'value':this.numberParseFloat(item.analyseBankDataMessageList[i].revisionRateByQues)+'%'})
                  //this.classAnalyse[10].data.push({'value':this.numberParseFloat(item.analyseBankDataMessageList[i].rightRate)+'%'})
                  this.classAnalyse[10].data.push({'value':this.timems2min(item.analyseBankDataMessageList[i].aveTime)})
                  this.classAnalyse[11].data.push({'value':item.analyseBankDataMessageList[i].microlessoncount})
                  this.classAnalyse[12].data.push({'value':this.timems2min(item.analyseBankDataMessageList[i].microlessontime)})
                }
              })
              this.copyClassAnalyse=this.classAnalyse
            }
            let that=this
            this.$nextTick(()=>{
              let sortable
                const ops = {
                    animation: 200,
                    group: "name",
                    onEnd: function (evt) {
                        let arr = sortable.toArray()
                        let newArr=[]
                        arr.forEach((item)=>{
                          newArr.push(JSON.parse(item))
                        })
                        that.copyTeacherAnalyse=newArr
                    },
                }
                sortable = Sortable.create(this.$refs.handTitle, ops)

                let sortableclass
                const opsclass = {
                    animation: 200,
                    group: "name",
                    onEnd: function (evt) {
                        let arr = sortableclass.toArray()
                        let newArr=[]
                        arr.forEach((item)=>{
                          newArr.push(JSON.parse(item))
                        })
                        that.copyClassAnalyse=newArr 
                    },
                }
                //初始化
                sortableclass = Sortable.create(this.$refs.handTitle2, opsclass)
            })
          } else {
            this.loadingTeach = false
            this.teacherList = []
            this.classData = []
          }
        })
    },
    toDetail (item, index) {
      if(item.teacherid){
        this.$router.push({
          path: "/detailGeneral",
          query: {
            teacherid: item.teacherid,
            // teachername: this.fixTeaname(item.teacherName),
            teachername: item.value,
            index,
          },
        })
      }
    },
    // 一键还原
    reduction(){
     this.$router.go(0)
    },
    onTeacherChange(item){
      item.isCheck=!item.isCheck
      for(let  i=0;i<this.copyTeacherAnalyse.length;i++){
        if(item.title==this.copyTeacherAnalyse[i].title){
          this.copyTeacherAnalyse[i].isCheck=item.isCheck
        }
      }
    },
    onClassChange(item){
      item.isCheck=!item.isCheck
      for(let  i=0;i<this.copyClassAnalyse.length;i++){
        if(item.title==this.copyClassAnalyse[i].title){
          this.copyClassAnalyse[i].isCheck=item.isCheck
        }
      }
    },
    handleTableChange (pagination) {
      this.pagination.current = pagination.current
      this.getAllexerciseTable()
    },
    fixTeaname (name) {
      var newname = name
      switch (name) {
        case "林娜伊":
          newname = "钱洪洲"
          break

        case "杨四妹":
          newname = "黄兴"
          break
        case "林敏君":
          newname = "单根坤"
          break
        case "张娇娜":
          newname = "胡萍萍"
          break
        case "钟颖":
          newname = "孟建娣"
          break
      }
      return newname
    },
    // 教学质量知识点
    getKnowanalyse () {
      this.loadingList = true
      this.knowpage.page = 1
      this.$http
        .get("/v1/learnonly/aianalyse/v2/knowanalyse", {
          params: {
            // orgid: 36,
            orgid: this.$store.getters.orgid,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            stageid: this.formData.stageid,
            gradeid: this.formData.gradeIds,
            subjectid: this.formData.subjectId,
            classid: this.formData.classid,
            // classid: this.formData.classid == 287 ? 232 : 233,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.loadingList = false
            this.knowledgeList = res.data.data.knowData
            this.knowpage.rowCount = res.data.data.knowData.length
          } else {
            this.loadingList = false
            this.knowledgeList = []
          }
        })
    },
    pageKnowledge (current) {
      this.knowpage.page = current
    },
    // 问卷调查
    getQuesnair () {
      var urlnair = ""
      process.env.VUE_APP_BASE_API == "http://192.168.0.248:8091/api/"
        ? (urlnair = "http://192.168.0.248:8095")
        : (urlnair = "https://console.learnonly.com")
      this.$http
        .get(
          urlnair + "/service/system/app/learnonlyos/statistics/Questionnaire",
          {
            params: {
              stateId: this.formData.stageid,
              gradeId: this.formData.gradeIds,
              subjectId: this.formData.subjectId,
              classId: this.formData.classid,
            },
          }
        )
        .then((res) => {
          if (res.data.status == 1) {
            this.quesnairtData = res.data.data.questData
            this.quesnairtStu = res.data.data.studentCounts
            this.stuSuggestionList =
              res.data.data.questData[4].stuSuggestionList
          }
        })
    },

    //设备详情近一周近一月切换
    radioChange () {
      if (this.spinning)
        return this.$message.warning("正在加载数据,请稍后...", 1)
      this.getDeviceDetailsInfoParams.month = ""
      this.commonGet()
    },

    //选择时间
    dateChange (val) {
      if (this.spinning)
        return this.$message.warning("正在加载数据,请稍后...", 1)
      if (val) {
        this.getDeviceDetailsInfoParams.weekOrMonth = 0
        this.getDeviceDetailsInfoParams.month = val

        this.commonGet()
      }
    },

    // 获取头部设备信息
    async getDeviceDetailsInfo () {
      try {
        const { data: res } = await this.$http.get(`v1/statement/getcount`, {
          params: {
            weekOrMonth: this.getDeviceDetailsInfoParams.weekOrMonth,
            month: this.getDeviceDetailsInfoParams.month,
            orgId: this.formData.classid == 0 ? this.$store.getters.orgid : "",
            // orgId: 11,
            classId: this.formData.classid != 0 ? this.formData.classid : "",
          },
        })
        // console.log(res)
        if (res.code != 200) return this.$message.warning(res.message)
        this.deviceDetailsInfo = res.data
      } catch (error) {
        return this.$message.warning("未知错误,请联系管理员")
      }
    },

    //获取学生活跃情况
    async getActiveSituation () {
      try {
        const { data: res } = await this.$http.get(`v1/statement/brisk`, {
          params: {
            weekOrMonth: this.getDeviceDetailsInfoParams.weekOrMonth,
            month: this.getDeviceDetailsInfoParams.month,
            orgId: this.formData.classid == 0 ? this.$store.getters.orgid : "",
            // orgId: 11,
            classId: this.formData.classid != 0 ? this.formData.classid : "",
          },
        })
        // console.log(res)
        if (res.code != 200) return this.$message.warning(res.message)
        this.activeSituationList = res.data

        //针对虹景让数据好看些
        if(Object.keys(this.activeSituationList).length > 0){
          for (const i in this.activeSituationList) {
            const item = this.activeSituationList[i]
            let highFrequency = item.highFrequency
            let lowFrequency = item.lowFrequency
            let unused = item.unused
            item.highFrequency = unused
            item.lowFrequency = highFrequency
            item.unused = lowFrequency
          }
        }

        if (Object.keys(this.activeSituationList).length > 0) {
          this.deviceChartOptions.xAxis.categories = Object.keys(
            this.activeSituationList
          )
          // 高频使用
          let curItem1 = this.deviceChartOptions.series.find((item1) => {
            return item1.id === 1
          })
          // 低频使用
          let curItem2 = this.deviceChartOptions.series.find((item1) => {
            return item1.id === 2
          })
          // 未使用
          let curItem3 = this.deviceChartOptions.series.find((item1) => {
            return item1.id === 3
          })
          curItem1.data = []
          curItem2.data = []
          curItem3.data = []
          for (const i in this.activeSituationList) {
            if (Object.hasOwnProperty.call(this.activeSituationList, i)) {
              const item = this.activeSituationList[i]
              if (item.date) {
                if (curItem1) {
                  curItem1.data.push(item.highFrequency)
                }
                if (curItem2) {
                  curItem2.data.push(item.lowFrequency)
                }
                if (curItem3) {
                  curItem3.data.push(item.unused)
                }
              } else {
                if (curItem1) {
                  curItem1.data.push(0)
                }
                if (curItem2) {
                  curItem2.data.push(0)
                }
                if (curItem3) {
                  curItem3.data.push(0)
                }
              }
            }
          }
        }
      } catch (error) {
        return this.$message.warning("未知错误,请联系管理员")
      }
    },

    //获取用户人均使用时长
    async getServiceDuration () {
      try {
        const { data: res } = await this.$http.get(
          `v1/statement/capiteUsedTime`,
          {
            params: {
              weekOrMonth: this.getDeviceDetailsInfoParams.weekOrMonth,
              month: this.getDeviceDetailsInfoParams.month,
              orgId:
                this.formData.classid == 0 ? this.$store.getters.orgid : "",
              // orgId: 11,
              classId: this.formData.classid != 0 ? this.formData.classid : "",
            },
          }
        )
        // console.log(res)
        if (res.code != 200) return this.$message.warning(res.message)
        this.serviceDurationInfo = res.data
        if (Object.keys(this.serviceDurationInfo).length > 0) {
          this.networkMonitoringOptions.xAxis.categories = Object.keys(
            this.serviceDurationInfo
          )
          let curItem = this.networkMonitoringOptions.series.find((item) => {
            return item.id === 1 //人均使用时长
          })
          curItem.data = []
          for (const i in this.serviceDurationInfo) {
            if (Object.hasOwnProperty.call(this.serviceDurationInfo, i)) {
              const item = this.serviceDurationInfo[i]
              if (curItem) {
                curItem.data.push(item)
              }
            }
          }
        }
      } catch (error) {
        return this.$message.warning("未知错误,请联系管理员")
      }
    },

    handleServiceDurationTableChange (pagination, filters, sorter) {
      const pager = { ...this.serviceDurationPage }
      pager.current = pagination.current
      this.serviceDurationPage = pager
      this.getServiceDurationTableInfo({
        sortOrder: sorter.order || "",
      })
    },

    //获取用户人均使用时长详情
    async getServiceDurationTableInfo (sorter = { sortOrder: "" }) {
      try {
        let sorterInfo = sorter
        console.log(sorterInfo)
        this.serviceDurationTableLoading = true
        const { data: res } = await this.$http.get(
          `v1/statement/usedTimeDetails`,
          {
            params: {
              date: this.perCapitaDetailsDate,
              orgId:
                this.formData.classid == 0 ? this.$store.getters.orgid : "",
              // orgId: 11,
              classId: this.formData.classid != 0 ? this.formData.classid : "",
              pageNum: this.serviceDurationPage.current,
              pageSize: this.serviceDurationPage.pageSize,
              sortOrder: sorterInfo.sortOrder,
            },
          }
        )
        console.log(res)
        if (res.code != 200) return this.$message.warning(res.message)
        if (res.length > 0) {
          this.modal2Visible = true
          const pagination = { ...this.serviceDurationPage }
          // Read total count from server
          // pagination.total = data.totalCount;
          pagination.total = res.length
          this.serviceDurationTableLoading = false
          this.serviceDurationPage = pagination
          this.serviceDurationTableInfo = res.data
          console.log(this.serviceDurationTableInfo)
        }
      } catch (error) {
        return this.$message.warning("未知错误,请联系管理员")
      }
    },

    //获取各应用人均使用时长
    async getAppDurationInfo () {
      // try {
      this.appDurationOptions.series = []
      this.columns1 = [
        {
          title: "学生姓名",
          dataIndex: "stuName",
          align: "center",
          width: 150,
        },
      ] //重置
      const { data: response } = await this.$http.get(
        `v1/statement/getAllAppName `
      )
      // console.log(response)
      if (response.code != 200) return this.$message.warning(response.message)
      if (response.data.length == 0) return // 应用数据为空的时候不需要再请求下面的数据了,下面数据为空
      this.appTypeList = response.data
      console.log(response.data)
      response.data.forEach((appItem) => {
        let appOptions = {
          name: appItem,
          data: [],
          tooltip: {
            valueSuffix: "分钟",
          },
        }
        this.appDurationOptions.series.push(appOptions)
        // table的配置项
        this.columns1.push({
          title: appItem,
          dataIndex: appItem,
          align: "center",
          sorter: true,
          width: 150,
          customRender: (text, record, index) => {
            if (!text) {
              return (text = "00 小时 00 分钟")
            }
            return this.formatTime(text)
          },
        })
      })
      const { data: res } = await this.$http.get(
        `v1/statement/capiteAppUsedTime`,
        {
          params: {
            weekOrMonth: this.getDeviceDetailsInfoParams.weekOrMonth,
            month: this.getDeviceDetailsInfoParams.month,
            orgId: this.formData.classid == 0 ? this.$store.getters.orgid : "",
            // orgId: 11,
            classId: this.formData.classid != 0 ? this.formData.classid : "",
          },
        }
      )
      console.log(res)
      if (res.code != 200) return this.$message.warning(res.message)
      this.appDurationInfo = res.data

      if (Object.keys(this.appDurationInfo).length > 0) {
        this.appDurationOptions.xAxis.categories = Object.keys(
          this.appDurationInfo
        )
      }

      let appDurationInfoKeys = Object.keys(this.appDurationInfo)
      if (appDurationInfoKeys.length > 0) {
        // ======== 重排后台数据 START ========
        for (let i = 0; i < this.appTypeList.length; i++) {
          for (let j = 0; j < appDurationInfoKeys.length; j++) {
            const element = this.appDurationInfo[appDurationInfoKeys[j]]
            if (element.length > 0) {
              for (let k = 0; k < element.length; k++) {
                if (element[k].appName != this.appTypeList[i]) {
                  if (
                    element.findIndex(
                      (ele) => ele.appName == this.appTypeList[i]
                    ) >= 0
                  )
                    continue
                  element.push({
                    appName: this.appTypeList[i],
                    appTime: 0,
                  })
                  break
                }
                continue
              }
            } else {
              element.push({
                appName: this.appTypeList[i],
                appTime: 0,
              })
            }
          }
        }
        // ======== 重排后台数据 END ========

        for (const key in this.appDurationInfo) {
          if (Object.hasOwnProperty.call(this.appDurationInfo, key)) {
            const item = this.appDurationInfo[key]
            for (let m = 0; m < this.appDurationOptions.series.length; m++) {
              let item1 = item.find(
                (ele1) => ele1.appName == this.appDurationOptions.series[m].name
              )
              this.appDurationOptions.series[m].data.push(item1.appTime)
            }
          }
        }
        console.log("appDurationInfo", this.appDurationInfo)
        console.log(this.appDurationOptions.series)
      }
      this.spinning = false
      // } catch (error) {
      //   return this.$message.warning("未知错误,请联系管理员")
      // }
    },

    handleAppDurationTableChange (pagination, filters, sorter) {
      const pager = { ...this.appDurationPage }
      pager.current = pagination.current
      this.appDurationPage = pager
      this.getAppDurationTableInfo({
        sortField: sorter.field || "",
        sortOrder: sorter.order || "",
      })
    },

    //获取各应用人均使用时长详情
    async getAppDurationTableInfo (sorter = { sortField: "", sortOrder: "" }) {
      console.log(2222, this.appDurationPage)
      try {
        let sorterInfo = sorter
        console.log(sorterInfo)
        this.appDurationTableLoading = true
        const { data: res } = await this.$http.get(
          `v1/statement/usedAppTimeDetails`,
          {
            params: {
              date: this.appDetailsDate,
              orgId:
                this.formData.classid == 0 ? this.$store.getters.orgid : "",
              // orgId: 11,
              classId: this.formData.classid != 0 ? this.formData.classid : "",
              pageNum: this.appDurationPage.current,
              pageSize: this.appDurationPage.pageSize,
              sortField: sorterInfo.sortField,
              sortOrder: sorterInfo.sortOrder,
            },
          }
        )
        console.log(res)
        if (res.code != 200) return this.$message.warning(res.message)
        if (res.length > 0) {
          this.modal1Visible = true
          const pagination = { ...this.appDurationPage }
          // Read total count from server
          // pagination.total = data.totalCount;
          pagination.total = res.length
          this.appDurationTableLoading = false
          this.appDurationPage = pagination
          this.appDurationTableInfo = res.data
          console.log(this.appDurationTableInfo)
        }
      } catch (error) {
        return this.$message.warning("未知错误,请联系管理员")
      }
    },
    // 导出班级使用分析数据
    classTableToExcel () {
      // this.teacherList = res.data.data.bankData
      let classDataArr=[]
      this.classData.forEach((item)=>{
        item.analyseBankDataMessageList.forEach((k)=>{
          k.className=item.className
          if(parseInt(k.scoreRate) < 60){
            k.scoreRateGrade='未达标'
          }else if(parseInt(k.scoreRate) >= 80){
            k.scoreRateGrade='优秀'
          }else{
            k.scoreRateGrade='达标'
          }
          if(parseInt(k.revisionRateByQues) < 80){
            k.revisionRateGrade='未达标'
          }else if(parseInt(k.revisionRateByQues) >= 100){
            k.revisionRateGrade='优秀'
          }else{
            k.revisionRateGrade='达标'
          }
          classDataArr.push(k)
        })
      })
      if (classDataArr.length != 0) {
        var jsonData = []
        for (let i = 0; i < classDataArr.length; i++) {
          jsonData.push({
            className: classDataArr[i].className,
            bankName: classDataArr[i].bankName,
            scoreRate: classDataArr[i].scoreRate + '%',
            scoreRateGrade:classDataArr[i].scoreRateGrade,
            revisionRate: classDataArr[i].revisionRateByQues + '%',
            revisionRateGrade: classDataArr[i].revisionRateGrade,
          })
        }
        let str = `班级,学科,得分率,得分率达标情况,订正率,订正率达标情况\n`
        for (let i = 0; i < jsonData.length; i++) {
          for (let item in jsonData[i]) {
            str += `${jsonData[i][item]},`
          }
          str += "\n"
        }
        let uri = "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(str)
        let link = document.createElement("a")
        link.href = uri
        link.download = "班级使用分析" + ".csv"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else {
        this.$message.warning("暂无数据可导出")
      }
    },
    // 导出各学科使用分析数据
    subjectTableToExcel () {
      // this.teacherList = res.data.data.bankData
      let teacherDataArr=[]
      this.teacherList.forEach((item)=>{
        item.analyseBankDataMessageList.forEach((k)=>{
          k.bankName=item.bankName
          k.avgScoreRate=item.avgScoreRate
          if(parseInt(k.scoreRate) < 60){
            k.scoreRateGrade='未达标'
          }else if(parseInt(k.scoreRate) >= 80){
            k.scoreRateGrade='优秀'
          }else{
            k.scoreRateGrade='达标'
          }
          if(parseInt(k.revisionRateByQues) < 80){
            k.revisionRateGrade='未达标'
          }else if(parseInt(k.revisionRateByQues) >= 100){
            k.revisionRateGrade='优秀'
          }else{
            k.revisionRateGrade='达标'
          }
          teacherDataArr.push(k)
        })
      })
      if (teacherDataArr.length != 0) {
        var jsonData = []
        for (let i = 0; i < teacherDataArr.length; i++) {
          jsonData.push({
            bankName: teacherDataArr[i].bankName,
            avgScoreRate: teacherDataArr[i].avgScoreRate + '%',
            teacherName: teacherDataArr[i].teacherName,
            scoreRateGrade:teacherDataArr[i].scoreRateGrade,
            revisionRate: teacherDataArr[i].revisionRateByQues + '%',
            revisionRateGrade: teacherDataArr[i].revisionRateGrade,
          })
        }
        let str = `学科,学科得分率,老师,老师得分率达标情况,订正率,订正率达标情况\n`
        for (let i = 0; i < jsonData.length; i++) {
          for (let item in jsonData[i]) {
            str += `${jsonData[i][item]},`
          }
          str += "\n"
        }
        let uri = "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(str)
        let link = document.createElement("a")
        link.href = uri
        link.download = "各科老师分析" + ".csv"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else {
        this.$message.warning("暂无数据可导出")
      }
    },
    // 老师原始数据导出
    originalSubjectToExcel(){
      let that=this
      if(!that.showCheckbox){
        that.showCheckbox=true
      }else{
        // 导出
        that.$confirm({
        title: '确认导出吗?',
        content: '',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          let str=[]
          let newTeacherAnalyse=[]
          that.copyTeacherAnalyse.forEach((item)=>{
            if(item.isCheck){
              str.push(item.title)
              newTeacherAnalyse.push(item)
            }
          })

          str=str.toString() + '\n'
          let newArr=[]
          for(let i=0;i<newTeacherAnalyse[0].data.length;i++){
              let arr=[]
              newTeacherAnalyse.forEach((item)=>{
                  arr.push(item.data[i].value.toString())
              })
              newArr.push(arr.toString())
          }
          for(let k=0;k<newArr.length;k++){
            str += `${newArr[k]}`
            str += "\n"
          }
          
          let uri = "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(str)
          let link = document.createElement("a")
          link.href = uri
          link.download = "各科老师分析" + ".csv"
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        },
        onCancel() {
          that.showCheckbox=false
          that.teacherAnalyse.forEach((item)=>{
            item.isCheck=true
          })
          that.copyTeacherAnalyse.forEach((item)=>{
            item.isCheck=true
          })
        },
      })
        
      }
    },
    // 班级原始数据
    originalClassToExcel(){
      let that=this
      if(!that.classShowCheckbox){
        that.classShowCheckbox=true
      }else{
        // 导出
        that.$confirm({
        title: '确认导出吗?',
        content: '',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          let str=[]
          let newClassAnalyse=[]
          that.copyClassAnalyse.forEach((item)=>{
            if(item.isCheck){
              str.push(item.title)
              newClassAnalyse.push(item)
            }
          })
          str=str.toString() + '\n'
          let newArr=[]
          for(let i=0;i<newClassAnalyse[0].data.length;i++){
              let arr=[]
              newClassAnalyse.forEach((item)=>{
                  arr.push(item.data[i].value.toString())
              })
              newArr.push(arr.toString())
          }
          for(let k=0;k<newArr.length;k++){
            str += `${newArr[k]}`
            str += "\n"
          }
          let uri = "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(str)
          let link = document.createElement("a")
          link.href = uri
          link.download = "班级使用分析" + ".csv"
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        },
        onCancel() {
          that.showCheckbox=false
          that.classAnalyse.forEach((item)=>{
            item.isCheck=true
          })
          that.copyClassAnalyse.forEach((item)=>{
            item.isCheck=true
          })
        },
      })
      }
    },
  },
  components: {
    mTabbar,
  },
  filters: {
    // 保留两位小数去0
    parseFloat (num) {
      if (num == undefined) {
        return "0"
      } else {
        var val = parseFloat(num).toFixed(2)
        return parseFloat(val)
      }
    },
    ms2min (ms) {
      if (ms) {
        var min = Math.floor((ms / 1000 / 60) << 0)
        var sec = Math.floor((ms / 1000) % 60)
        return min + "分" + sec + "秒"
      } else {
        return "/"
      }
    },
  },
  computed: {
    formatTime () {
      return (t) => {
        if (t < 3600)
          return (
            "" +
            ((a = parseInt(t / 60)) < 10 ? "0" + a : a) +
            " 小时 " +
            ((i = t % 60) < 10 ? "0" + i : i) +
            " 分钟"
          )
        if (3600 <= t) {
          var a,
            i,
            e = parseInt(t / 3600)
          return (
            (e < 10 ? "0" + e : e) +
            " 小时 " +
            ((a = parseInt((t % 3600) / 60)) < 10 ? "0" + a : a) +
            " 分钟 " +
            ((i = t % 60) < 10 ? "0" + i : i) +
            " 秒"
          )
        }
      }
    },
  },

  created () {
    let year = new Date().getFullYear()
    let month = new Date().getMonth()
    for (let i = 1; i < month + 1; i++) {
      //获取到的月份必须是已经过完的月份
      this.monthList.unshift(year + "-" + (i < 10 ? "0" + i : i))
    }
  },
  mounted () {
    // 判断是否从正道远过来的
    sessionStorage.getItem("isZdy") != null
      ? (this.mTabbarType = false)
      : (this.mTabbarType = true)
    this.$route.query.currTab == undefined
      ? (this.currTab = 0)
      : (this.currTab = this.$route.query.currTab)
    // 判断当前日期是否在固定区间内
    var date = {
      isDuringDate: function (beginDateStr, endDateStr) {
        var curDate = new Date(),
          beginDate = new Date(beginDateStr),
          endDate = new Date(endDateStr)
        if (curDate >= beginDate && curDate <= endDate) {
          return true
        }
        return false
      },
    }
    this.isTrue = date.isDuringDate(
      new Date().getFullYear() + "/02/01",
      new Date().getFullYear() + "/09/01"
    )
    // if (this.isTrue) {
    //   this.form.startTime = moment(new Date().getFullYear() + '/09/01').format(
    //     'YYYY-MM-DD'
    //   )
    //   //   this.form.endTime = moment( new Date().getFullYear() + Date().getFullYear()).format('YYYY-MM-DD')
    // } else {
    //   this.form.startTime = moment(
    //     new Date().getFullYear() - 1 + '/02/01'
    //   ).format('YYYY-MM-DD')
    //   //   this.form.endTime = moment(new Date().getFullYear() + '/09/01').format('YYYY-MM-DD')
    // }
    this.form.startTime = moment(new Date())
      .subtract(1, "weeks")
      .format("YYYY-MM-DD")
    // this.form.startTime = moment('2020/01/01').format('YYYY-MM-DD')
    this.form.endTime = moment()
      .subtract(1, "days")
      .format("YYYY-MM-DD")
    this.getAlllinkage()
    this.$nextTick(() => {
      this.commonGet()
    })
    let _this = this
    //点击人均使用时长详情
    $(document).on("click", ".perCapitaDetails", function (e) {
      e.preventDefault()
      _this.perCapitaDetailsDate = $(e.currentTarget).attr("date")
      _this.serviceDurationPage.current = 1

      _this.getServiceDurationTableInfo()
    })

    //点击app人均使用时长详情
    $(document).on("click", ".appDetails", function (e) {
      e.preventDefault()
      _this.appDetailsDate = $(e.currentTarget).attr("date")
      _this.appDurationPage.current = 1

      _this.getAppDurationTableInfo()
    })
  },
}
</script>
<style scoped>
/* 问卷调查 */
.nairBody {
  padding: 10px 15px;
}
.nairBody .nairLi {
  margin-bottom: 25px;
}
.nairLi h2 {
  font-size: 16px;
  font-weight: 600;
}
.nairLi > p {
  color: #9d9d9d;
  margin-bottom: 14px;
}
.nairLi .progress {
  position: relative;
  margin-bottom: 10px;
}
.progress .pTitle {
  position: absolute;
  left: 10px;
  top: 6px;
  color: #fff;
}
.progress .pNum {
  position: absolute;
  right: 20px;
  top: 6px;
}
.pNum span:first-child {
  padding-right: 20px;
}
/deep/.nairdarkrow {
  background: #f6f8fa;
}
.nairBody /deep/.ant-progress-inner {
  border-radius: 5px;
  background-color: #fff;
  border: 1px solid #dae1ef;
}
.nairBody /deep/.ant-progress-bg {
  border-radius: 0 !important;
}
.nairBody /deep/.ant-progress-status-success .ant-progress-bg {
  background-color: #1992fc;
}
.nairBody /deep/.ant-table-bordered .ant-table-body > table {
  border: 1px solid #dae1ef !important;
}
.nairBody /deep/.ant-table-thead > tr:first-child > th > div {
  font-weight: normal;
  color: #9d9d9d;
}
.nairBody /deep/.ant-table-thead > tr > th {
  background: #fff;
  padding: 8px 10px;
  border-bottom: 1px solid #dae1ef;
}
.nairBody /deep/.ant-table-tbody > tr > td {
  padding: 0 10px;
  border-bottom: 1px solid #dae1ef;
}
.nairBody /deep/.ant-table-bordered .ant-table-thead > tr > th {
  border-right: none;
}
.nairBody /deep/.ant-table-bordered .ant-table-tbody > tr > td {
  border-right: none;
}
/* 问卷调查结束 */
/deep/ p {
  margin: 0;
  padding: 0;
}
/* .manageNew {
  margin-top: 64px;
} */
.bodyLeft {
  position: fixed;
  background: #050919;
  height: 100%;
  width: 200px;
  text-align: center;
  z-index: 0;
}

/* .bodyLeft::after {
  width: 200px;
  height: 65px;
  content: '';
  position: absolute;
  top: -65px;
  left: 0;
  background: url('../../assets/images/logo-full.png') no-repeat #001529 16px
    20px;
  background-size: 160px 27px;
} */
.bodyLeft h3 {
  color: #fff;
  border-radius: 5px;
  /* background: #3d81ff; */
}
.bodyLeft div {
  background: #1e273d;
  margin-bottom: 5px;
  height: 84vh;
  text-align: center;
  overflow: auto;
  display: block;
  padding: 10px 20px;
}
.bodyLeft div::-webkit-scrollbar {
  width: 0;
}
.bodyLeft div p {
  color: #fff;
  display: block;
  line-height: 38px;
  cursor: pointer;
  text-align: center;

  overflow: hidden; /* 超出的文本隐藏 */
  text-overflow: ellipsis; /*溢出用省略号显示 */
  white-space: nowrap; /*溢出不换行*/
}
.bodyLeft .classActive {
  background: #3d81ff;
  border-radius: 5px;
}

/* 1 */
.bodyRight {
  flex: auto;
  width: 100%;
  background: #fff;
  margin: 0;
  padding: 0;
  padding-left: 200px;
  display: block;
}
.headFixed {
  background: #fff;
  z-index: 99;
}
.detail-box {
}
.boxFirst {
  overflow: hidden;
  padding: 10px 15px 15px;
  border-bottom: 1px solid #eee;
}
.boxFirst .selectHead {
  overflow: hidden;
  float: left;
  padding-top: 5px;
}
.selectHead > li {
  float: left;
  padding: 6px 12px;
  cursor: pointer;
  border: 1px solid #40a9ff;
}
.selectHead > li:first-child {
  border-right: none;
}
.selectHead > li:nth-child(3) {
  border-left: none;
}
.selectHead > li:last-child {
  border-left: none;
}
.selectHead .liContent {
  color: #fff;
  border: 1px solid #40a9ff;
  background: #40a9ff;
  /* margin-right: 10px; */
}
.dataend {
  float: right;
  font-size: 13px;
  color: #e4393c;
  padding: 10px 18px 0 0;
  display:flex;
  align-items:center;
}
/deep/.ant-form-item-label label {
  font-weight: 600;
}
/deep/.ant-radio-button-wrapper-checked {
  background: #1890ff;
  color: #fff;
}
/deep/.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  color: #fff;
}
.nocharts {
  height: 400px;
  padding-top: 160px;
  text-align: center;
}
/* 手写表格 */
.handTable {
  width: 100%;
  overflow-x: scroll;
}
.handTable > div {
  width: 1600px;
}
.moreLength > div {
  width: 1707px;
}
.handTable .hand-title {
  overflow: hidden;
  border: 1px solid #e8e8e8;
  background: #efefef;
  position: relative;
}
.hand-title li {
  font-weight: 600;
}
.handTable li {
  float: left;
  text-align: center;
}
.handTable .l1 {
  width: 10%;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 7px 0px;
}
.handTable .l2 {
  margin-left: 10%;
}
.handTable .l2 div {
  overflow: hidden;
  border-bottom: 1px solid #e8e8e8;
}
.handTable .l2 div:last-child {
  border-bottom: none;
}
.handTable .l2 p {
  width: 110px;
  float: left;
  padding: 7px 5px;
  border-left: 1px solid #e8e8e8;
}
.hand-title .l2 p {
  font-weight: 600;
}
.hand-title .l2 p span {
  font-weight: 600;
}
.handTable .hand-detail {
  overflow: hidden;
  border: 1px solid #e8e8e8;
  border-bottom: none;
  position: relative;
}
.hand-detail .colorName {
  color: #1890ff;
  cursor: pointer;
}
/* 手写表格结束 */
/* 2 */
.boxSecond {
  width: 100%;
  overflow: hidden;
  padding: 15px 15px 5px;
  border-bottom: 5px solid #eee;
}
.boxSecond > ul {
  overflow: hidden;
  width: 100%;
  margin: 0 auto;
  padding: 15px 0;
  margin-bottom: 20px;
}
.boxSecond > ul > li {
  float: left;
  width: 25%;
  margin-bottom: 10px;
  overflow: hidden;
}
.boxSecond > ul > li > img {
  width: 45px;
  height: 45px;
  float: left;
  margin-right: 10px;
}
.boxSecond > ul > li p {
  font-size: 13px;
}
.boxSecond > ul > li h3 {
  font-weight: 600;
}
.boxSecond > div {
  overflow: hidden;
}
.boxSecond .timeLeft {
  width: 55%;
  float: left;
}
.tabanalyse {
  text-align: center;
  margin: 10px 0;
}
.boxSecond .cakeRight {
  width: 45%;
  float: left;
}
.cakaTitle {
  text-align: center;
  cursor: pointer;
}
.cakaTitle i {
  font-size: 18px;
  color: #333;
  margin-right: 5px;
}
/* 3 */
.boxThird {
  width: 100%;
  padding: 15px 15px 5px;
}
.boxThird > h1 {
  font-size: 16px;
  font-weight: 600;
}
/* 滚动条 */
/deep/.ant-table-body::-webkit-scrollbar {
  height: 8px;
}
/deep/.ant-table-tbody > tr {
  line-height: 33px;
  height: 33px;
}
/deep/.ant-table-thead > tr > th {
  padding: 8px 0px;
  background: #efefef;
}
/deep/.ant-table-tbody > tr > td {
  padding: 0px 0px;
}
/deep/.ant-table-tbody > tr > td:first-child {
  padding: 0 10px;
  /* width: 100%; */
  overflow: hidden;
  /* display: inline-block; */
  white-space: nowrap;
  text-overflow: ellipsis;
}
/deep/.ant-table-thead > tr:first-child > th > div {
  font-weight: 600;
}
/deep/.ant-table-thead > tr:first-child > th > div span {
  font-weight: 600;
}
/deep/.ant-table-thead > tr:first-child > th:first-child {
  padding: 0 10px;
}
.titleUl {
  overflow: hidden;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  background: #efefef;
}
.titleUl li {
  float: left;
  width: 9%;
  padding: 10px 0px;
  text-align: center;
  border-left: 1px solid #e8e8e8;
  font-weight: 600;
}
.titleUl li:first-child {
  border-left: none;
}
.titleUl li:last-child {
  border-right: none;
}
.detailUl {
  background: #fafafa;
  border: 1px solid #e8e8e8;
}
.boxThird .detailUl li {
  overflow: hidden;
  text-align: center;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
  position: relative;
}
.detailUl li > div {
  float: left;
}
.boxThird .detailUl li > div:first-child {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.boxThird .detailUl li > div:last-child {
  width: 91%;
  margin-left: 9%;
}
.detailUl li .liDiv {
  overflow: hidden;
  border-bottom: 1px solid #e8e8e8;
}
.detailUl li .liDiv:last-child {
  border-bottom: none;
}
.detailUl li .liDiv p {
  float: left;
  width: 9.9%;
  padding: 8px 0px;
  text-align: center;
  border-left: 1px solid #e8e8e8;
}
/deep/.ant-tag {
  width: 100%;
  border: none;
  font-size: 14px;
  background: none;
  border-radius: 0;
  line-height: 35px;
  height: 35px;
  cursor: auto;
}
.noData {
  padding: 16px 16px;
  color: rgba(0, 0, 0, 0.45);
  border-bottom: 1px solid #e8e8e8;
}
/* 教学质量 */
.boxTeach {
  width: 100%;
  padding: 15px 15px 5px;
}
.boxTeach > h1 {
  font-size: 16px;
  font-weight: 600;
}
.boxTeach .titleUl li {
  float: left;
  width: 13%;
  padding: 10px 0px;
  text-align: center;
  border-right: 1px solid #e8e8e8;
  font-weight: 600;
}
.titleUl li span {
  font-weight: 600;
}
.boxTeach .titleUl .l1 {
  width: 23%;
}
.boxTeach .titleUl .l2 {
  width: 12%;
}
.boxTeach .detailUl li {
  overflow: hidden;
  text-align: center;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
  position: relative;
}
.boxTeach .detailUl li:last-child {
  border-bottom: none;
}
.boxTeach .detailUl li > div:last-child {
  width: 65%;
  margin-left: 35%;
}
.boxTeach .detailUl .l1 {
  width: 23%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  display: inline-block;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.boxTeach .detailUl .l2 {
  width: 12%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 23%;
  transform: translate(0, -50%);
  border-left: 1px solid #e8e8e8;
  display: table;
}
.boxTeach .detailUl .l2 > span {
  display: table-cell;
  vertical-align: middle;
}
.boxTeach .detailUl li .liDiv {
  overflow: hidden;
}
.boxTeach .detailUl li .liDiv p:first-child {
  color: #1890ff;
  cursor: pointer;
}
.boxTeach .detailUl li p {
  float: left;
  width: 20%;
  text-align: center;
  padding: 6px 0;
}
/deep/.darkrow {
  background: #f4f4f4;
}
.green {
  background-color: #53c41a;
  color: #fff;
}
.orange {
  background-color: #eba215;
  color: #fff;
}
.red {
  background-color: rgb(236 66 75);
  color: #fff;
}
.deviceDetails-box {
  margin-top: 180px;
}
.deviceDetails-header {
  position: relative;
}
.deviceDetails-select {
  float: right;
  padding: 20px 35px 10px 15px;
}
.deviceDetails-select >>> .ant-radio-button-wrapper {
  margin-right: 8px;
  border-radius: 4px;
  border-left: 1px solid #d9d9d9;
}
.deviceDetails-select >>> .ant-radio-button-wrapper:not(:first-child)::before {
  display: none;
}
.deviceDetails-select >>> .ant-radio-button-wrapper-checked {
  box-shadow: 0 0 0 #1890ff;
}
.deviceDetails-select >>> .ant-radio-button-wrapper-checked:hover {
  box-shadow: 0 0 0 #409aff;
}
.deviceDetails-select >>> .ant-select-selection {
  /* border: 0; */
}
.deviceDetails-select > span:last-of-type >>> ul > li {
  text-align: left;
}
.deviceDetails-info {
  float: left;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-bottom: 20px;
  padding: 20px 20px 0;
}
.deviceDetails-info .tips {
  position: absolute;
  right: 20px;
  top: 10px;
}
.deviceDetails-info .tips >>> .tips-content .ant-tooltip-inner {
  min-width: 14em;
  line-height: 1.65;
  max-width: 14em;
  text-align: center;
}
.deviceDetails-info > div {
  width: 12vw;
  min-width: 8em;
  border-radius: 8px;
  padding: 15px 0;
  text-align: center;
  margin: 0 15px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.deviceDetails-info > div > p:last-of-type {
  min-width: 6em;
  margin-top: 0.5em;
}

.deviceDetails {
  padding: 20px;
}

.deviceDetails .activeSituation {
  height: 65vh;
  margin-bottom: 3em;
}

.deviceDetails .networkMonitoring {
  height: 60vh;
  margin-bottom: 3em;
}

.deviceDetails .appDuration {
  height: 60vh;
}

.rounded {
  border-radius: 10px;
}

.deviceDetails >>> .green {
  background: #82c8a0;
}

.deviceDetails >>> .btn-two.green {
  background-color: #9abf7f;
}

.deviceDetails >>> .btn-two {
  text-align: center;
  color: #fff;
  padding: 5px 20px;
  width: 100%;
  cursor: pointer;
  letter-spacing: 2px;
  display: inline-block;
  border: 1px solid rgba(0, 0, 0, 0.21);
  border-bottom-color: rgba(0, 0, 0, 0.34);
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.34) inset,
    0 2px 0 -1px rgba(0, 0, 0, 0.13), 0 3px 0 -1px rgba(0, 0, 0, 0.08),
    0 3px 13px -1px rgba(0, 0, 0, 0.21);
}
.deviceDetails >>> .btn-two:active {
  top: 1px;
  border-color: rgba(0, 0, 0, 0.34) rgba(0, 0, 0, 0.21) rgba(0, 0, 0, 0.21);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.89), 0 1px rgba(0, 0, 0, 0.05) inset;
  position: relative;
}
.appModelTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.appModelTitle > span:last-of-type {
  flex: 1;
  text-align: center;
  margin-left: -4em;
  font-weight: 700;
}

.deviceDetails-table >>> .ant-table {
  min-height: 50vh;
}

.deviceDetails-table >>> .ant-table td {
  white-space: nowrap;
}

.deviceDetails >>> .custom-tooltip {
  max-height: 8em;
  overflow: auto;
}
.deviceDetails >>> .custom-tooltip > p {
}

.deviceDetails .resetPosition >>> .ant-spin {
  position: fixed;
}

.deviceDetails .resetPosition >>> .ant-spin-dot {
  left: 40%;
}
.handContent:hover{
  cursor: move;
}
.handContent{
  border: 1px solid #e8e8e8;
}
.handHead{
  font-weight:600!important;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* padding: 7px 0px; */
  width:120px;
  height:35px;
  text-align:center;
  line-height:35px;
  border-bottom: 1px solid #e8e8e8;
  background: #efefef;
}
.handBody{
  width:120px;
  height:35px;
  text-align:center;
  line-height:35px;
  border-bottom: 1px solid #e8e8e8;
  /* border-left:1px solid #e8e8e8; */
}
.colorName {
  color: #1890ff;
  cursor: pointer;
}
</style>
<style>
.noneSelect {
  display: none;
}
.ant-tooltip {
  max-width: 338px;
}
/* 选择器下拉框固定 */
.ant-select-dropdown {
  position: fixed !important;
}
.export {
  cursor: pointer;
  color: #fff;
  background: #1890ff;
  border: 1px solid #1890ff;
  border-radius: 5px;
  padding: 7px 10px;
  float:right;
  margin-top:-5px;
  margin-right:15px;
}
.common{
  margin-bottom:20px;
}
</style>
